export const dict = {
  "en": {
    "content": "Content Management",
    "appName": "1930 Training Simulator",
    "appSub": "I4C Call Taker Training",
    "badgeNumber": "Badge Number",
    "password": "Password",
    "login": "Login",
    "loggingIn": "Logging in...",
    "signIn": "Sign in to your training account",
    "dashboard": "Dashboard",
    "mcq": "Scenario MCQ",
    "liveCall": "Live Call",
    "ncrpForm": "NCRP Form",
    "caseStudies": "Case Studies",
    "reference": "Reference Guide",
    "sop": "SOP Guide",
    "analytics": "Analytics",
    "profile": "Profile",
    "users": "User Management",
    "adminDashboard": "Admin Overview",
    "logout": "Logout",
    "avgScore": "Average Score",
    "totalSessions": "Sessions",
    "rank": "Rank",
    "topMistakes": "Top Mistakes",
    "quickStart": "Quick Start",
    "startTraining": "Start Training",
    "categoryProgress": "Category Progress",
    "welcome": "Welcome back",
    "noMistakes": "No mistakes recorded yet — keep practising!",
    "difficulty": "Difficulty",
    "easy": "Easy",
    "medium": "Medium",
    "hard": "Hard",
    "start": "Start",
    "submit": "Submit",
    "next": "Next",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "explanation": "Explanation",
    "yourScore": "Your Score",
    "finish": "Finish",
    "review": "Post-Call Review",
    "callScript": "Call Script",
    "question": "Question",
    "selectAnswer": "Select your answer",
    "scenarios": "Scenarios",
    "formNarrative": "Complaint Narrative",
    "validate": "Validate & Submit",
    "commonMistake": "Common Mistake",
    "correctAnswer": "Correct Answer",
    "yourEntry": "Your Entry",
    "allCorrect": "All fields correct!",
    "save": "Save Changes",
    "editProfile": "Edit Profile",
    "designation": "Designation",
    "state": "State",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "name": "Name",
    "role": "Role",
    "search": "Search",
    "export": "Export",
    "importUsers": "Import Users",
    "downloadTemplate": "Download Template",
    "delete": "Delete",
    "makeAdmin": "Make Admin",
    "makeTrainee": "Make Trainee",
    "leaderboard": "Leaderboard",
    "categoryDistribution": "Category Distribution",
    "stateDrilldown": "State Drill-down",
    "trend": "Activity Trend",
    "createdAt": "Created",
    "actions": "Actions",
    "attempts": "Attempts",
    "lesson": "Lesson",
    "pattern": "Observed Pattern",
    "searchTaxonomy": "Search crime categories...",
    "txnFormat": "Transaction ID Format",
    "portal": "NCRP Portal Section",
    "checklist": "Checklist",
    "importResult": "Import Result",
    "created": "Created",
    "errors": "Errors",
    "back": "Back",
    "lang": "Language",
    "noData": "No data yet",
    "loading": "Loading...",
    "doAsk": "Do Ask",
    "dontAsk": "Don't Ask / Never Do",
    "govOfIndia": "Government of India",
    "mha": "Ministry of Home Affairs",
    "helpline": "1930 Helpline",
    "i4c": "Indian Cyber Crime Coordination Centre (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "A Government of India initiative to facilitate victims / complainants to report cybercrime complaints online",
    "natlHelpline": "NATIONAL HELPLINE",
    "i4cCentre": "Indian Cyber Crime Coordination Centre",
    "screenReader": "Screen Reader Access",
    "marquee": "For reporting online financial fraud, call the National Helpline 1930 immediately. Cybercrimes must be reported within 24 hours to maximise recovery chances of frozen funds. This is an internal training simulator — synthetic data only."
  },
  "hi": {
    "appName": "1930 प्रशिक्षण सिम्युलेटर",
    "appSub": "आई4सी कॉल टेकर प्रशिक्षण",
    "badgeNumber": "बैज नंबर",
    "password": "पासवर्ड",
    "login": "लॉगिन",
    "loggingIn": "लॉगिन हो रहा है...",
    "signIn": "अपने प्रशिक्षण खाते में साइन इन करें",
    "dashboard": "डैशबोर्ड",
    "mcq": "परिदृश्य एमसीक्यू",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी फॉर्म",
    "caseStudies": "केस स्टडी",
    "reference": "संदर्भ गाइड",
    "sop": "एसओपी गाइड",
    "analytics": "विश्लेषण",
    "profile": "प्रोफ़ाइल",
    "users": "उपयोगकर्ता प्रबंधन",
    "adminDashboard": "एडमिन अवलोकन",
    "logout": "लॉगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्र",
    "rank": "रैंक",
    "topMistakes": "शीर्ष गलतियां",
    "quickStart": "त्वरित प्रारंभ",
    "startTraining": "प्रशिक्षण शुरू करें",
    "categoryProgress": "श्रेणी प्रगति",
    "welcome": "वापसी पर स्वागत है",
    "noMistakes": "अभी तक कोई गलती दर्ज नहीं — अभ्यास जारी रखें!",
    "difficulty": "कठिनाई",
    "easy": "आसान",
    "medium": "मध्यम",
    "hard": "कठिन",
    "start": "शुरू करें",
    "submit": "जमा करें",
    "next": "अगला",
    "correct": "सही",
    "incorrect": "गलत",
    "explanation": "स्पष्टीकरण",
    "yourScore": "आपका स्कोर",
    "finish": "समाप्त",
    "review": "कॉल के बाद समीक्षा",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "प्रश्न",
    "selectAnswer": "अपना उत्तर चुनें",
    "scenarios": "परिदृश्य",
    "formNarrative": "शिकायत विवरण",
    "validate": "सत्यापित करें और जमा करें",
    "commonMistake": "आम गलती",
    "correctAnswer": "सही उत्तर",
    "yourEntry": "आपकी प्रविष्टि",
    "allCorrect": "सभी फ़ील्ड सही!",
    "save": "परिवर्तन सहेजें",
    "editProfile": "प्रोफ़ाइल संपादित करें",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदलें",
    "currentPassword": "वर्तमान पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "name": "नाम",
    "role": "भूमिका",
    "search": "खोजें",
    "export": "निर्यात",
    "importUsers": "उपयोगकर्ता आयात",
    "downloadTemplate": "टेम्पलेट डाउनलोड करें",
    "delete": "हटाएं",
    "makeAdmin": "एडमिन बनाएं",
    "makeTrainee": "ट्रेनी बनाएं",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य विश्लेषण",
    "trend": "गतिविधि रुझान",
    "createdAt": "बनाया गया",
    "actions": "कार्रवाई",
    "attempts": "प्रयास",
    "lesson": "सबक",
    "pattern": "देखा गया पैटर्न",
    "searchTaxonomy": "अपराध श्रेणियां खोजें...",
    "txnFormat": "लेन-देन आईडी प्रारूप",
    "portal": "एनसीआरपी पोर्टल अनुभाग",
    "checklist": "चेकलिस्ट",
    "importResult": "आयात परिणाम",
    "created": "बनाए गए",
    "errors": "त्रुटियां",
    "back": "वापस",
    "lang": "English",
    "noData": "अभी कोई डेटा नहीं",
    "loading": "लोड हो रहा है...",
    "doAsk": "यह पूछें",
    "dontAsk": "यह न पूछें / कभी न करें",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "भारतीय साइबर अपराध समन्वय केंद्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "साइबर अपराध की शिकायत ऑनलाइन दर्ज कराने हेतु भारत सरकार की पहल",
    "natlHelpline": "राष्ट्रीय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केंद्र",
    "screenReader": "स्क्रीन रीडर एक्सेस",
    "marquee": "ऑनलाइन वित्तीय धोखाधड़ी की रिपोर्ट के लिए तुरंत राष्ट्रीय हेल्पलाइन 1930 पर कॉल करें। साइबर अपराध 24 घंटे के भीतर रिपोर्ट करें ताकि फ्रीज़ राशि की वसूली की संभावना बढ़े। यह एक आंतरिक प्रशिक्षण सिम्युलेटर है — केवल सिंथेटिक डेटा।"
  },
  "as": {
    "appName": "১৯৩০ চনৰ প্ৰশিক্ষণ চিমুলেটৰ",
    "appSub": "I4C কল টেকাৰ প্ৰশিক্ষণ",
    "badgeNumber": "বেজ নম্বৰ",
    "password": "পাছৱৰ্ড",
    "login": "লগইন",
    "loggingIn": "লগ ইন কৰি আছে...",
    "signIn": "আপোনাৰ প্ৰশিক্ষণ একাউণ্টত চাইন ইন কৰক",
    "dashboard": "ডেচবোৰ্ড",
    "mcq": "দৃশ্যপট MCQ",
    "liveCall": "লাইভ কল",
    "ncrpForm": "এন চি আৰ পি প্ৰ-পত্ৰ",
    "caseStudies": "কেছ ষ্টাডিজ",
    "reference": "ৰেফাৰেন্স গাইড",
    "sop": "SOP গাইড",
    "analytics": "বিশ্লেষণ",
    "profile": "প্ৰফাইল",
    "users": "ব্যৱহাৰকাৰী ব্যৱস্থাপনা",
    "adminDashboard": "এডমিন অভাৰভিউ",
    "logout": "লগআউট",
    "avgScore": "গড় স্ক'ৰ",
    "totalSessions": "অধিবেশন",
    "rank": "ৰেংক",
    "topMistakes": "শীৰ্ষ ভুল",
    "quickStart": "দ্ৰুত আৰম্ভ",
    "startTraining": "প্ৰশিক্ষণ আৰম্ভ কৰক",
    "categoryProgress": "শ্ৰেণীৰ অগ্ৰগতি",
    "welcome": "পুনৰ স্বাগতম",
    "noMistakes": "এতিয়াও কোনো ভুল ৰেকৰ্ড কৰা হোৱা নাই — অনুশীলন কৰি থাকিব!",
    "difficulty": "অসুবিধা",
    "easy": "সহজ",
    "medium": "মধ্যমীয়া",
    "hard": "কঠিন",
    "start": "আৰম্ভ কৰক",
    "submit": "জমা দিয়ক",
    "next": "পৰৱৰ্তী",
    "correct": "শুদ্ধকৈ",
    "incorrect": "ভুল",
    "explanation": "ব্যাখ্যা",
    "yourScore": "আপোনাৰ স্ক'ৰ",
    "finish": "সমাপ্ত",
    "review": "কলৰ পিছৰ পৰ্যালোচনা",
    "callScript": "কল স্ক্ৰিপ্ট",
    "question": "প্ৰশ্ন",
    "selectAnswer": "আপোনাৰ উত্তৰ নিৰ্বাচন কৰক",
    "scenarios": "দৃশ্যপট",
    "formNarrative": "অভিযোগ আখ্যান",
    "validate": "বৈধতা & জমা দিব",
    "commonMistake": "সাধাৰণ ভুল",
    "correctAnswer": "শুদ্ধ উত্তৰ",
    "yourEntry": "আপোনাৰ প্ৰৱেশ",
    "allCorrect": "সকলো ক্ষেত্ৰ শুদ্ধ!",
    "save": "পৰিবৰ্তন সংৰক্ষণ কৰক",
    "editProfile": "প্ৰফাইল সম্পাদনা কৰক",
    "designation": "পদবী",
    "state": "ৰাজ্য",
    "changePassword": "পাছৱৰ্ড সলনি কৰক",
    "currentPassword": "বৰ্তমানৰ পাছৱৰ্ড",
    "newPassword": "নতুন পাছৱৰ্ড",
    "name": "নাম",
    "role": "ভূমিকা",
    "search": "সন্ধান",
    "export": "ৰপ্তানি",
    "importUsers": "আমদানি ব্যৱহাৰকাৰী",
    "downloadTemplate": "ডাউনলোড টেমপ্লেট",
    "delete": "মচি পেলাওক",
    "makeAdmin": "এডমিন বনাওক",
    "makeTrainee": "প্ৰশিক্ষাৰ্থী বনাওক",
    "leaderboard": "লিডাৰবোৰ্ড",
    "categoryDistribution": "শ্ৰেণী বিতৰণ",
    "stateDrilldown": "ৰাজ্যিক ড্ৰিল-ডাউন",
    "trend": "কাৰ্য্যকলাপৰ প্ৰৱণতা",
    "createdAt": "সৃষ্টি কৰা হৈছে",
    "actions": "কৰ্ম",
    "attempts": "চেষ্টা",
    "lesson": "পাঠ",
    "pattern": "পৰ্যবেক্ষণ কৰা আৰ্হি",
    "searchTaxonomy": "অপৰাধৰ শিতানত সন্ধান...",
    "txnFormat": "লেনদেন আইডি বিন্যাস",
    "portal": "এন চি আৰ পি পৰ্টেল শাখা",
    "checklist": "পৰীক্ষা তালিকা",
    "importResult": "আমদানি ফলাফল",
    "created": "সৃষ্টি কৰা হৈছে",
    "errors": "ভুল",
    "back": "পিছলৈ",
    "lang": "ভাষা",
    "noData": "এতিয়ালৈকে কোনো তথ্য নাই",
    "loading": "লোড হৈ আছে...",
    "doAsk": "কৰক সুধিব",
    "dontAsk": "নাসোধক / কেতিয়াও নকৰিব",
    "govOfIndia": "ভাৰত চৰকাৰ",
    "mha": "গৃহ পৰিক্ৰমা মন্ত্ৰালয়",
    "helpline": "১৯৩০ হেল্পলাইন",
    "i4c": "ভাৰতীয় চাইবাৰ অপৰাধ সমন্বয় কেন্দ্ৰ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "চাইবাৰ অপৰাধৰ অভিযোগ অনলাইনত দাখিল কৰাত পীড়িত/অভিযোগকাৰীক সুবিধা দিবলৈ ভাৰত চৰকাৰৰ এক পদক্ষেপ",
    "natlHelpline": "ৰাষ্ট্ৰীয় হেল্পলাইন",
    "i4cCentre": "ভাৰতীয় চাইবাৰ অপৰাধ সমন্বয় কেন্দ্ৰ",
    "screenReader": "স্ক্ৰীণ ৰিডাৰৰ প্ৰৱেশ",
    "marquee": "অনলাইন বিত্তীয় জালিয়াতিৰ ৰিপৰ্ট দিবলৈ তৎক্ষণাত নেচনেল হেল্পলাইন ১৯৩০লৈ ফোন কৰক। চাইবাৰ অপৰাধৰ ৰিপৰ্ট ২৪ ঘণ্টাৰ ভিতৰত দিব লাগিব যাতে ফ্ৰ'জেন ফাণ্ডৰ আদায়ৰ সম্ভাৱনা সৰ্বাধিক হয়। এইটো এটা আভ্যন্তৰীণ প্ৰশিক্ষণ চিমুলেটৰ — কেৱল কৃত্ৰিম তথ্য।"
  },
  "bn": {
    "appName": "1930 প্রশিক্ষণ সিমুলেটর",
    "appSub": "I4C কল টেকার ট্রেনিং",
    "badgeNumber": "ব্যাজ নম্বর",
    "password": "পাসওয়ার্ড",
    "login": "লগইন",
    "loggingIn": "লগ ইন...",
    "signIn": "আপনার প্রশিক্ষণ অ্যাকাউন্টে সাইন ইন করুন",
    "dashboard": "ড্যাশবোর্ড",
    "mcq": "দৃশ্যকল্প MCQ",
    "liveCall": "লাইভ কল",
    "ncrpForm": "NCRP ফর্ম",
    "caseStudies": "কেস স্টাডিজ",
    "reference": "রেফারেন্স গাইড",
    "sop": "এসওপি গাইড",
    "analytics": "বিশ্লেষণ",
    "profile": "প্রোফাইল",
    "users": "ব্যবহারকারী ব্যবস্থাপনা",
    "adminDashboard": "অ্যাডমিন ওভারভিউ",
    "logout": "লগ আউট",
    "avgScore": "গড় স্কোর",
    "totalSessions": "সেশনস",
    "rank": "র‍্যাঙ্ক",
    "topMistakes": "শীর্ষ ভুল",
    "quickStart": "দ্রুত শুরু",
    "startTraining": "প্রশিক্ষণ শুরু করুন",
    "categoryProgress": "বিভাগ অগ্রগতি",
    "welcome": "আবার স্বাগতম",
    "noMistakes": "এখনও কোন ভুল রেকর্ড করা হয়নি — অনুশীলন চালিয়ে যান!",
    "difficulty": "অসুবিধা",
    "easy": "সহজ",
    "medium": "মাঝারি",
    "hard": "কঠিন",
    "start": "শুরু করুন",
    "submit": "জমা দিন",
    "next": "পরবর্তী",
    "correct": "সঠিক",
    "incorrect": "ভুল",
    "explanation": "ব্যাখ্যা",
    "yourScore": "আপনার স্কোর",
    "finish": "শেষ করুন",
    "review": "পোস্ট-কল রিভিউ",
    "callScript": "কল স্ক্রিপ্ট",
    "question": "প্রশ্ন",
    "selectAnswer": "আপনার উত্তর নির্বাচন করুন",
    "scenarios": "দৃশ্যকল্প",
    "formNarrative": "অভিযোগের আখ্যান",
    "validate": "যাচাই করুন এবং জমা দিন",
    "commonMistake": "সাধারণ ভুল",
    "correctAnswer": "সঠিক উত্তর",
    "yourEntry": "আপনার এন্ট্রি",
    "allCorrect": "সব ক্ষেত্র সঠিক!",
    "save": "পরিবর্তনগুলি সংরক্ষণ করুন",
    "editProfile": "প্রোফাইল সম্পাদনা করুন",
    "designation": "পদবী",
    "state": "রাজ্য",
    "changePassword": "পাসওয়ার্ড পরিবর্তন করুন",
    "currentPassword": "বর্তমান পাসওয়ার্ড",
    "newPassword": "নতুন পাসওয়ার্ড",
    "name": "নাম",
    "role": "ভূমিকা",
    "search": "অনুসন্ধান",
    "export": "রপ্তানি",
    "importUsers": "ব্যবহারকারীদের আমদানি করুন",
    "downloadTemplate": "টেমপ্লেট ডাউনলোড করুন",
    "delete": "মুছুন",
    "makeAdmin": "অ্যাডমিন করুন",
    "makeTrainee": "ট্রেইনি করুন",
    "leaderboard": "লিডারবোর্ড",
    "categoryDistribution": "বিভাগ বন্টন",
    "stateDrilldown": "রাজ্য ড্রিল-ডাউন",
    "trend": "কার্যকলাপ প্রবণতা",
    "createdAt": "তৈরি করা হয়েছে",
    "actions": "কর্ম",
    "attempts": "প্রচেষ্টা",
    "lesson": "পাঠ",
    "pattern": "পর্যবেক্ষণ করা প্যাটার্ন",
    "searchTaxonomy": "অপরাধের বিভাগ অনুসন্ধান করুন...",
    "txnFormat": "লেনদেন আইডি ফরম্যাট",
    "portal": "NCRP পোর্টাল বিভাগ",
    "checklist": "চেকলিস্ট",
    "importResult": "আমদানি ফলাফল",
    "created": "তৈরি করা হয়েছে",
    "errors": "ত্রুটি",
    "back": "ফিরে",
    "lang": "ভাষা",
    "noData": "এখনো কোন তথ্য নেই",
    "loading": "লোড হচ্ছে...",
    "doAsk": "জিজ্ঞাসা করুন",
    "dontAsk": "জিজ্ঞাসা করবেন না / কখনও করবেন না",
    "govOfIndia": "ভারত সরকার",
    "mha": "স্বরাষ্ট্র মন্ত্রণালয়",
    "helpline": "1930 হেল্পলাইন",
    "i4c": "ইন্ডিয়ান সাইবার ক্রাইম কোঅর্ডিনেশন সেন্টার (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "অনলাইনে সাইবার ক্রাইম অভিযোগ জানাতে ভিকটিম/অভিযোগকারীদের সুবিধার্থে ভারত সরকারের একটি উদ্যোগ",
    "natlHelpline": "ন্যাশনাল হেল্পলাইন",
    "i4cCentre": "ভারতীয় সাইবার ক্রাইম সমন্বয় কেন্দ্র",
    "screenReader": "স্ক্রিন রিডার অ্যাক্সেস",
    "marquee": "অনলাইন আর্থিক জালিয়াতি রিপোর্ট করার জন্য, অবিলম্বে জাতীয় হেল্পলাইন 1930 এ কল করুন। হিমায়িত তহবিল পুনরুদ্ধারের সম্ভাবনা সর্বাধিক করতে 24 ঘন্টার মধ্যে সাইবার অপরাধের রিপোর্ট করতে হবে। এটি একটি অভ্যন্তরীণ প্রশিক্ষণ সিমুলেটর — শুধুমাত্র সিন্থেটিক ডেটা।"
  },
  "brx": {
    "appName": "1930 के प्रशिक्षण सिम्युलेटर",
    "appSub": "आई 4 सी कॉल टेकर के प्रशिक्षण",
    "badgeNumber": "बिल्ला नंबर",
    "password": "पासवर्ड के बा",
    "login": "लॉगिन करीं",
    "loggingIn": "लॉग इन कर रहल बानी...",
    "signIn": "अपना ट्रेनिंग अकाउंट में साइन इन करीं",
    "dashboard": "डैशबोर्ड के बा",
    "mcq": "परिदृश्य एमसीक्यू के बा",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी के फार्म",
    "caseStudies": "केस स्टडीज के बारे में बतावल गइल बा",
    "reference": "संदर्भ गाइड के बा",
    "sop": "एसओपी गाइड",
    "analytics": "एनालिटिक्स के बारे में",
    "profile": "प्रोफाइल",
    "users": "उपयोगकर्ता प्रबंधन के बारे में",
    "adminDashboard": "एडमिन के अवलोकन",
    "logout": "लॉगआउट करीं",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्र के बारे में",
    "rank": "रैंक",
    "topMistakes": "टॉप गलती",
    "quickStart": "जल्दी से शुरू होखे के",
    "startTraining": "ट्रेनिंग शुरू कर दीं",
    "categoryProgress": "श्रेणी के प्रगति",
    "welcome": "वापस स्वागत बा",
    "noMistakes": "अभी तक कवनो गलती दर्ज नइखे भइल — अभ्यास करत रहीं!",
    "difficulty": "कठिनाई हो गईल",
    "easy": "आसान बा",
    "medium": "मध्यम के",
    "hard": "कठिन",
    "start": "शुरू कर दीं",
    "submit": "जमा कर दीं",
    "next": "अगिला",
    "correct": "सही बा",
    "incorrect": "गलत बा",
    "explanation": "समझावत बा",
    "yourScore": "राउर स्कोर",
    "finish": "खतम करीं",
    "review": "कॉल के बाद के समीक्षा",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "सवाल बा",
    "selectAnswer": "आपन जवाब चुनीं",
    "scenarios": "परिदृश्य के बारे में",
    "formNarrative": "शिकायत के बखान",
    "validate": "मान्य & जमा करे के बा",
    "commonMistake": "आम गलती",
    "correctAnswer": "सही जवाब बा",
    "yourEntry": "राउर प्रविष्टि",
    "allCorrect": "सब फील्ड सही बा!",
    "save": "बदलाव के बचाईं",
    "editProfile": "प्रोफाइल संपादित करीं",
    "designation": "पदनाम",
    "state": "राज्य के",
    "changePassword": "पासवर्ड बदले के बा",
    "currentPassword": "वर्तमान पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "name": "नाम के नाम",
    "role": "भूमिका",
    "search": "खोजत बानी",
    "export": "निर्यात करे के बा",
    "importUsers": "आयात करे वाला प्रयोगकर्ता",
    "downloadTemplate": "टेम्पलेट डाउनलोड करीं",
    "delete": "हटा दिहल जाव",
    "makeAdmin": "एडमिन बनाईं",
    "makeTrainee": "प्रशिक्षु बनाईं",
    "leaderboard": "लीडरबोर्ड के बा",
    "categoryDistribution": "श्रेणी के वितरण के बारे में",
    "stateDrilldown": "राज्य के ड्रिल-डाउन",
    "trend": "गतिविधि के रुझान",
    "createdAt": "रचले बानी",
    "actions": "कर्म के",
    "attempts": "कोशिश कइल गइल",
    "lesson": "सबक बा",
    "pattern": "देखल गइल पैटर्न",
    "searchTaxonomy": "अपराध श्रेणी के खोज करीं...",
    "txnFormat": "लेनदेन आईडी प्रारूप",
    "portal": "एनसीआरपी पोर्टल अनुभाग",
    "checklist": "चेकलिस्ट के बा",
    "importResult": "आयात के रिजल्ट",
    "created": "रचले बानी",
    "errors": "गलती हो गईल बा",
    "back": "वापस",
    "lang": "भाषा के",
    "noData": "अभी तक कवनो डाटा ना",
    "loading": "लोड हो रहल बा...",
    "doAsk": "कर पूछे के बा",
    "dontAsk": "मत पूछीं / कभी ना करीं",
    "govOfIndia": "भारत सरकार के",
    "mha": "गृह मंत्रालय के",
    "helpline": "1930 के हेल्पलाइन",
    "i4c": "भारतीय साइबर अपराध समन्वय केंद्र (आई 4 सी)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "पीड़ित / शिकायतकर्ता के साइबर अपराध के शिकायत ऑनलाइन रिपोर्ट करे में सुविधा देवे खातिर भारत सरकार के एगो पहल",
    "natlHelpline": "राष्ट्रीय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केंद्र",
    "screenReader": "स्क्रीन रीडर के पहुँच",
    "marquee": "ऑनलाइन वित्तीय धोखाधड़ी के रिपोर्ट करे खातिर तुरंत नेशनल हेल्पलाइन 1930 प फोन करीं। जमल धन के वसूली के संभावना अधिका से अधिका होखे खातिर साइबर अपराध के 24 घंटा का भीतर रिपोर्ट करे के पड़ी. ई एगो आंतरिक प्रशिक्षण सिम्युलेटर हवे — खाली सिंथेटिक डेटा।"
  },
  "doi": {
    "appName": "1930 प्रशिक्षण सिम्युलेटर",
    "appSub": "आई 4 सी कॉल टेकर ट्रेनिंग",
    "badgeNumber": "बिल्ला नंबर",
    "password": "पासवर्ड",
    "login": "लॉगिन करो",
    "loggingIn": "लॉग इन करना...",
    "signIn": "अपने ट्रेनिंग खाते च साइन इन करो",
    "dashboard": "डैशबोर्ड",
    "mcq": "परिदृश्य एमसीक्यू",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी फार्म",
    "caseStudies": "केस स्टडीज",
    "reference": "संदर्भ गाइड",
    "sop": "एसओपी गाइड",
    "analytics": "एनालिटिक्स",
    "profile": "प्रोफाइल",
    "users": "उपयोगकर्ता प्रबंधन",
    "adminDashboard": "एडमिन अवलोकन",
    "logout": "लॉगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्रें",
    "rank": "रैंक",
    "topMistakes": "टॉप गलतियां",
    "quickStart": "जल्दी शुरू कर दे",
    "startTraining": "ट्रेनिंग शुरू करो",
    "categoryProgress": "श्रेणी प्रगति",
    "welcome": "फिर से आपका स्वागत है",
    "noMistakes": "अजे तक कोई गलती दर्ज नहीं कीती गई — अभ्यास करदे रहो !",
    "difficulty": "कठिनाई",
    "easy": "आसान",
    "medium": "मध्यम",
    "hard": "कठिन",
    "start": "शुरू कर दे",
    "submit": "जमा करो",
    "next": "अगला",
    "correct": "सही",
    "incorrect": "गलत",
    "explanation": "सफाई देना",
    "yourScore": "तेरा स्कोर",
    "finish": "पूरा करना",
    "review": "कॉल दे बाद दी समीक्षा",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "सवाल",
    "selectAnswer": "अपना जवाब चुनें",
    "scenarios": "परिदृश्य",
    "formNarrative": "शिकायत बखान",
    "validate": "वैलिडेट & सबमिट करना",
    "commonMistake": "आम गलती",
    "correctAnswer": "सही जवाब",
    "yourEntry": "तेरी एंट्री",
    "allCorrect": "सारे फील्ड सही !",
    "save": "बदलाव बचाओ",
    "editProfile": "प्रोफाइल संपादित करो",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदलो",
    "currentPassword": "वर्तमान पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "name": "नाम",
    "role": "भूमिका",
    "search": "खोजें",
    "export": "निर्यात करना",
    "importUsers": "आयात उपयोगकर्ता",
    "downloadTemplate": "डाउनलोड टेम्पलेट",
    "delete": "डिलीट कर दे",
    "makeAdmin": "एडमिन बनाओ",
    "makeTrainee": "प्रशिक्षु बनाओ",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "गतिविधि दा रुझान",
    "createdAt": "बनाया",
    "actions": "कर्मों",
    "attempts": "कोशिश करदे",
    "lesson": "सबक",
    "pattern": "अवलोकन पैटर्न",
    "searchTaxonomy": "अपराध श्रेणियाँ खोजें...",
    "txnFormat": "लेनदेन आईडी प्रारूप",
    "portal": "एनसीआरपी पोर्टल अनुभाग",
    "checklist": "चेकलिस्ट",
    "importResult": "आयात दा नतीजा",
    "created": "बनाया",
    "errors": "त्रुटियां",
    "back": "वापस",
    "lang": "भाशा",
    "noData": "अजे तक कोई डाटा नहीं",
    "loading": "लोड हो रहा है...",
    "doAsk": "कर पूछो",
    "dontAsk": "मत पूछो / कदे ना करो",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "भारतीय साइबर अपराध समन्वय केंद्र (आई 4 सी)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "पीड़ितें / शिकायतकर्ताएं गी साइबर अपराध दी शिकायतें गी ऑनलाइन रिपोर्ट करने च सुविधा देने लेई भारत सरकार दी इक पहल",
    "natlHelpline": "राष्ट्रीय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केंद्र",
    "screenReader": "स्क्रीन रीडर एक्सेस",
    "marquee": "आनलाइन माली धोखाधड़ी दी रिपोर्ट करने लेई, फौरन नेशनल हेल्पलाइन 1930 पर फोन करो। जमे दे फंडें दी वसूली दे संभावना गी मती बनाने लेई साइबर अपराधें दी रिपोर्ट 24 घैंटे दे अंदर कीती जानी चाहिदी। एह् इक आंतरिक प्रशिक्षण सिम्युलेटर ऐ — सिर्फ सिंथेटिक डेटा।"
  },
  "gu": {
    "appName": "1930 તાલીમ સિમ્યુલેટર",
    "appSub": "I4C કોલ ટેકર ટ્રેનિંગ",
    "badgeNumber": "બેજ નંબર",
    "password": "પાસવર્ડ",
    "login": "લૉગિન",
    "loggingIn": "લૉગ ઇન થઈ રહ્યું છે...",
    "signIn": "તમારા તાલીમ ખાતામાં સાઇન ઇન કરો",
    "dashboard": "ડેશબોર્ડ",
    "mcq": "દૃશ્ય MCQ",
    "liveCall": "લાઈવ કોલ",
    "ncrpForm": "NCRP ફોર્મ",
    "caseStudies": "કેસ સ્ટડીઝ",
    "reference": "સંદર્ભ માર્ગદર્શિકા",
    "sop": "એસઓપી માર્ગદર્શિકા",
    "analytics": "એનાલિટિક્સ",
    "profile": "પ્રોફાઇલ",
    "users": "યુઝર મેનેજમેન્ટ",
    "adminDashboard": "એડમિન વિહંગાવલોકન",
    "logout": "લોગઆઉટ",
    "avgScore": "સરેરાશ સ્કોર",
    "totalSessions": "સત્રો",
    "rank": "રેન્ક",
    "topMistakes": "ટોચની ભૂલો",
    "quickStart": "ઝડપી શરૂઆત",
    "startTraining": "તાલીમ શરૂ કરો",
    "categoryProgress": "શ્રેણી પ્રગતિ",
    "welcome": "ફરી સ્વાગત છે",
    "noMistakes": "હજુ સુધી કોઈ ભૂલો નોંધાઈ નથી — પ્રેક્ટિસ ચાલુ રાખો!",
    "difficulty": "મુશ્કેલી",
    "easy": "સરળ",
    "medium": "મધ્યમ",
    "hard": "સખત",
    "start": "શરુ કરો",
    "submit": "સબમિટ કરો",
    "next": "આગળ",
    "correct": "સાચું",
    "incorrect": "ખોટું",
    "explanation": "સમજૂતી",
    "yourScore": "તમારો સ્કોર",
    "finish": "સમાપ્ત કરો",
    "review": "પોસ્ટ-કોલ સમીક્ષા",
    "callScript": "કૉલ સ્ક્રિપ્ટ",
    "question": "પ્રશ્ન",
    "selectAnswer": "તમારો જવાબ પસંદ કરો",
    "scenarios": "દૃશ્યો",
    "formNarrative": "ફરિયાદ વર્ણન",
    "validate": "માન્ય કરો અને સબમિટ કરો",
    "commonMistake": "સામાન્ય ભૂલ",
    "correctAnswer": "સાચો જવાબ",
    "yourEntry": "તમારી એન્ટ્રી",
    "allCorrect": "બધા ક્ષેત્રો સાચા!",
    "save": "ફેરફારો સાચવો",
    "editProfile": "પ્રોફાઇલ સંપાદિત કરો",
    "designation": "હોદ્દો",
    "state": "રાજ્ય",
    "changePassword": "પાસવર્ડ બદલો",
    "currentPassword": "વર્તમાન પાસવર્ડ",
    "newPassword": "નવો પાસવર્ડ",
    "name": "નામ",
    "role": "ભૂમિકા",
    "search": "શોધો",
    "export": "નિકાસ",
    "importUsers": "આયાત વપરાશકર્તાઓ",
    "downloadTemplate": "ટેમ્પલેટ ડાઉનલોડ કરો",
    "delete": "કાઢી નાખો",
    "makeAdmin": "એડમિન બનાવો",
    "makeTrainee": "તાલીમાર્થી બનાવો",
    "leaderboard": "લીડરબોર્ડ",
    "categoryDistribution": "શ્રેણી વિતરણ",
    "stateDrilldown": "સ્ટેટ ડ્રીલ-ડાઉન",
    "trend": "પ્રવૃત્તિ વલણ",
    "createdAt": "બનાવ્યું",
    "actions": "ક્રિયાઓ",
    "attempts": "પ્રયાસો",
    "lesson": "પાઠ",
    "pattern": "અવલોકન કરેલ પેટર્ન",
    "searchTaxonomy": "ગુનાની શ્રેણીઓ શોધો...",
    "txnFormat": "ટ્રાન્ઝેક્શન ID ફોર્મેટ",
    "portal": "NCRP પોર્ટલ વિભાગ",
    "checklist": "ચેકલિસ્ટ",
    "importResult": "આયાત પરિણામ",
    "created": "બનાવ્યું",
    "errors": "ભૂલો",
    "back": "પાછળ",
    "lang": "ભાષા",
    "noData": "હજુ સુધી કોઈ ડેટા નથી",
    "loading": "લોડ કરી રહ્યું છે...",
    "doAsk": "પૂછો",
    "dontAsk": "પૂછશો નહીં/ક્યારેય કરશો નહીં",
    "govOfIndia": "ભારત સરકાર",
    "mha": "ગૃહ મંત્રાલય",
    "helpline": "1930 હેલ્પલાઈન",
    "i4c": "ભારતીય સાયબર ક્રાઈમ કોઓર્ડિનેશન સેન્ટર (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "સાયબર ક્રાઈમ ફરિયાદો ઓનલાઈન નોંધાવવા પીડિતો/ફરિયાદીઓને સુવિધા આપવા માટે ભારત સરકારની પહેલ",
    "natlHelpline": "નેશનલ હેલ્પલાઈન",
    "i4cCentre": "ભારતીય સાયબર ક્રાઈમ કોઓર્ડિનેશન સેન્ટર",
    "screenReader": "સ્ક્રીન રીડર એક્સેસ",
    "marquee": "ઓનલાઈન નાણાકીય છેતરપિંડીની જાણ કરવા માટે, તરત જ નેશનલ હેલ્પલાઈન 1930 પર કૉલ કરો. સ્થિર ભંડોળની પુનઃપ્રાપ્તિની શક્યતાને મહત્તમ કરવા માટે 24 કલાકની અંદર સાયબર ક્રાઇમ્સની જાણ કરવી આવશ્યક છે. આ એક આંતરિક તાલીમ સિમ્યુલેટર છે — માત્ર સિન્થેટિક ડેટા."
  },
  "kn": {
    "appName": "1930 ತರಬೇತಿ ಸಿಮ್ಯುಲೇಟರ್",
    "appSub": "I4C ಕಾಲ್ ಟೇಕರ್ ತರಬೇತಿ",
    "badgeNumber": "ಬ್ಯಾಡ್ಜ್ ಸಂಖ್ಯೆ",
    "password": "ಗುಪ್ತಪದ",
    "login": "ಲಾಗಿನ್",
    "loggingIn": "ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ...",
    "signIn": "ನಿಮ್ಮ ತರಬೇತಿ ಖಾತೆಗೆ ಸೈನ್ ಇನ್ ಮಾಡಿ",
    "dashboard": "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    "mcq": "ಸನ್ನಿವೇಶ MCQ",
    "liveCall": "ನೇರ ಕರೆ",
    "ncrpForm": "NCRP ಫಾರ್ಮ್",
    "caseStudies": "ಕೇಸ್ ಸ್ಟಡೀಸ್",
    "reference": "ಉಲ್ಲೇಖ ಮಾರ್ಗದರ್ಶಿ",
    "sop": "SOP ಮಾರ್ಗದರ್ಶಿ",
    "analytics": "ವಿಶ್ಲೇಷಣೆ",
    "profile": "ವಿವರ",
    "users": "ಬಳಕೆದಾರ ನಿರ್ವಹಣೆ",
    "adminDashboard": "ನಿರ್ವಾಹಕರ ಅವಲೋಕನ",
    "logout": "ಲಾಗ್ಔಟ್",
    "avgScore": "ಸರಾಸರಿ ಸ್ಕೋರ್",
    "totalSessions": "ಅವಧಿಗಳು",
    "rank": "ಶ್ರೇಣಿ",
    "topMistakes": "ಪ್ರಮುಖ ತಪ್ಪುಗಳು",
    "quickStart": "ತ್ವರಿತ ಪ್ರಾರಂಭ",
    "startTraining": "ತರಬೇತಿ ಪ್ರಾರಂಭಿಸಿ",
    "categoryProgress": "ವರ್ಗ ಪ್ರಗತಿ",
    "welcome": "ಮರಳಿ ಸ್ವಾಗತ",
    "noMistakes": "ಇನ್ನೂ ಯಾವುದೇ ತಪ್ಪುಗಳನ್ನು ದಾಖಲಿಸಲಾಗಿಲ್ಲ - ಅಭ್ಯಾಸವನ್ನು ಮುಂದುವರಿಸಿ!",
    "difficulty": "ಕಷ್ಟ",
    "easy": "ಸುಲಭ",
    "medium": "ಮಧ್ಯಮ",
    "hard": "ಕಠಿಣ",
    "start": "ಪ್ರಾರಂಭ",
    "submit": "ಸಲ್ಲಿಸು",
    "next": "ಮುಂದೆ",
    "correct": "ಸರಿ",
    "incorrect": "ತಪ್ಪು",
    "explanation": "ವಿವರಣೆ",
    "yourScore": "ನಿಮ್ಮ ಅಂಕ",
    "finish": "ಮುಗಿಸು",
    "review": "ಕರೆ ನಂತರದ ವಿಮರ್ಶೆ",
    "callScript": "ಕರೆ ಸ್ಕ್ರಿಪ್ಟ್",
    "question": "ಪ್ರಶ್ನೆ",
    "selectAnswer": "ನಿಮ್ಮ ಉತ್ತರವನ್ನು ಆರಿಸಿ",
    "scenarios": "ಸನ್ನಿವೇಶಗಳು",
    "formNarrative": "ದೂರಿನ ನಿರೂಪಣೆ",
    "validate": "ಮೌಲ್ಯೀಕರಿಸಿ ಮತ್ತು ಸಲ್ಲಿಸಿ",
    "commonMistake": "ಸಾಮಾನ್ಯ ತಪ್ಪು",
    "correctAnswer": "ಸರಿಯಾದ ಉತ್ತರ",
    "yourEntry": "ನಿಮ್ಮ ಪ್ರವೇಶ",
    "allCorrect": "ಎಲ್ಲಾ ಕ್ಷೇತ್ರಗಳು ಸರಿಯಾಗಿವೆ!",
    "save": "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    "editProfile": "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    "designation": "ಹುದ್ದೆ",
    "state": "ರಾಜ್ಯ",
    "changePassword": "ಪಾಸ್ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
    "currentPassword": "ಪ್ರಸ್ತುತ ಗುಪ್ತಪದ",
    "newPassword": "ಹೊಸ ಗುಪ್ತಪದ",
    "name": "ಹೆಸರು",
    "role": "ಪಾತ್ರ",
    "search": "ಹುಡುಕು",
    "export": "ರಫ್ತು",
    "importUsers": "ಬಳಕೆದಾರರನ್ನು ಆಮದು ಮಾಡಿ",
    "downloadTemplate": "ಟೆಂಪ್ಲೇಟ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "delete": "ಅಳಿಸು",
    "makeAdmin": "ನಿರ್ವಾಹಕರಾಗಿ ಮಾಡಿ",
    "makeTrainee": "ಟ್ರೇನಿ ಮಾಡಿ",
    "leaderboard": "ಲೀಡರ್‌ಬೋರ್ಡ್",
    "categoryDistribution": "ವರ್ಗ ವಿತರಣೆ",
    "stateDrilldown": "ರಾಜ್ಯ ಡ್ರಿಲ್-ಡೌನ್",
    "trend": "ಚಟುವಟಿಕೆ ಪ್ರವೃತ್ತಿ",
    "createdAt": "ರಚಿಸಿದ",
    "actions": "ಕ್ರಿಯೆಗಳು",
    "attempts": "ಪ್ರಯತ್ನಗಳು",
    "lesson": "ಪಾಠ",
    "pattern": "ಗಮನಿಸಿದ ನಮೂನೆ",
    "searchTaxonomy": "ಅಪರಾಧ ವಿಭಾಗಗಳನ್ನು ಹುಡುಕಿ...",
    "txnFormat": "ವಹಿವಾಟು ID ಸ್ವರೂಪ",
    "portal": "NCRP ಪೋರ್ಟಲ್ ವಿಭಾಗ",
    "checklist": "ಪರಿಶೀಲನಾಪಟ್ಟಿ",
    "importResult": "ಆಮದು ಫಲಿತಾಂಶ",
    "created": "ರಚಿಸಿದ",
    "errors": "ದೋಷಗಳು",
    "back": "ಹಿಂದೆ",
    "lang": "ಭಾಷೆ",
    "noData": "ಇನ್ನೂ ಡೇಟಾ ಇಲ್ಲ",
    "loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    "doAsk": "ಕೇಳು",
    "dontAsk": "ಕೇಳಬೇಡ / ಎಂದಿಗೂ ಮಾಡಬೇಡ",
    "govOfIndia": "ಭಾರತ ಸರ್ಕಾರ",
    "mha": "ಗೃಹ ವ್ಯವಹಾರಗಳ ಸಚಿವಾಲಯ",
    "helpline": "1930 ಸಹಾಯವಾಣಿ",
    "i4c": "ಭಾರತೀಯ ಸೈಬರ್ ಅಪರಾಧ ಸಮನ್ವಯ ಕೇಂದ್ರ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "ಸೈಬರ್ ಕ್ರೈಮ್ ದೂರುಗಳನ್ನು ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ವರದಿ ಮಾಡಲು ಸಂತ್ರಸ್ತರು / ದೂರುದಾರರಿಗೆ ಅನುಕೂಲವಾಗುವಂತೆ ಭಾರತ ಸರ್ಕಾರದ ಉಪಕ್ರಮ",
    "natlHelpline": "ರಾಷ್ಟ್ರೀಯ ಸಹಾಯವಾಣಿ",
    "i4cCentre": "ಭಾರತೀಯ ಸೈಬರ್ ಅಪರಾಧ ಸಮನ್ವಯ ಕೇಂದ್ರ",
    "screenReader": "ಸ್ಕ್ರೀನ್ ರೀಡರ್ ಪ್ರವೇಶ",
    "marquee": "ಆನ್‌ಲೈನ್ ಹಣಕಾಸು ವಂಚನೆಯನ್ನು ವರದಿ ಮಾಡಲು, ತಕ್ಷಣವೇ ರಾಷ್ಟ್ರೀಯ ಸಹಾಯವಾಣಿ 1930 ಗೆ ಕರೆ ಮಾಡಿ. ಫ್ರೋಜನ್ ಫಂಡ್‌ಗಳ ಚೇತರಿಕೆಯ ಸಾಧ್ಯತೆಗಳನ್ನು ಹೆಚ್ಚಿಸಲು ಸೈಬರ್ ಅಪರಾಧಗಳನ್ನು 24 ಗಂಟೆಗಳ ಒಳಗೆ ವರದಿ ಮಾಡಬೇಕು. ಇದು ಆಂತರಿಕ ತರಬೇತಿ ಸಿಮ್ಯುಲೇಟರ್ - ಸಂಶ್ಲೇಷಿತ ಡೇಟಾ ಮಾತ್ರ."
  },
  "ks": {
    "appName": "1930 ट्रेनिंग सिम्युलेटर",
    "appSub": "I4C कॉल टेकर ट्रेनिंग",
    "badgeNumber": "बैज नंबर",
    "password": "पासवर्ड",
    "login": "लॉगिन",
    "loggingIn": "लॉग इन गछान...",
    "signIn": "पनुन ट्रेनिंग अकाउंट मंज़ साइन इन करो",
    "dashboard": "डैशबोर्ड",
    "mcq": "सीन एमसीक्यू",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी फार्म",
    "caseStudies": "केस स्टडीज़",
    "reference": "संदर्भ गाइड",
    "sop": "एसओपी गाइड",
    "analytics": "एनालिटिक्स",
    "profile": "प्रोफाइल",
    "users": "यूज़र मैनेजमेंट",
    "adminDashboard": "एडमिन ओवरव्यू",
    "logout": "लॉगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सेशन",
    "rank": "रैंक",
    "topMistakes": "टॉप गलतियां",
    "quickStart": "जल्दी शुरू",
    "startTraining": "ट्रेनिंग शुरू करो",
    "categoryProgress": "श्रेणी तरक्की",
    "welcome": "वापस खुश आमदीद",
    "noMistakes": "हलचा तक कांह गलती दर्ज नहीं जाली — मश्क़ जारी राखो!",
    "difficulty": "मुश्किल",
    "easy": "आसान",
    "medium": "मध्यम",
    "hard": "मुश्किल",
    "start": "शुरू करो",
    "submit": "जमा करो",
    "next": "अगिली",
    "correct": "सही",
    "incorrect": "गलत",
    "explanation": "वज़ाहत",
    "yourScore": "तुहुंद स्कोर",
    "finish": "खतम करो",
    "review": "कॉल पतु समीक्षा",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "सवाल",
    "selectAnswer": "पनुन जवाब चुनो",
    "scenarios": "सीन",
    "formNarrative": "शिकायत बयान",
    "validate": "तसदीक़ करो त जमा करो",
    "commonMistake": "आम गलती",
    "correctAnswer": "सही जवाब",
    "yourEntry": "तुहुंद एंट्री",
    "allCorrect": "सारे फील्ड सही!",
    "save": "तबदीली महफूज़ करो",
    "editProfile": "प्रोफाइल एडिट करो",
    "designation": "ओहदा",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदलो",
    "currentPassword": "मौजूदा पासवर्ड",
    "newPassword": "नव पासवर्ड",
    "name": "नाव",
    "role": "रोल",
    "search": "तलाश",
    "export": "एक्सपोर्ट",
    "importUsers": "यूज़र इम्पोर्ट करो",
    "downloadTemplate": "टेम्पलेट डाउनलोड करो",
    "delete": "हटावो",
    "makeAdmin": "एडमिन बनावो",
    "makeTrainee": "ट्रेनी बनावो",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी तक़सीम",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "सरगर्मी रुझान",
    "createdAt": "बनावुन",
    "actions": "अमल",
    "attempts": "कोशिशां",
    "lesson": "सबक़",
    "pattern": "मुशाहिदा नमूना",
    "searchTaxonomy": "जुर्म श्रेणियां तलाश करो...",
    "txnFormat": "ट्रांज़ैक्शन आईडी फॉर्मेट",
    "portal": "एनसीआरपी पोर्टल सेक्शन",
    "checklist": "चेकलिस्ट",
    "importResult": "इम्पोर्ट नतीजा",
    "created": "बनावुन",
    "errors": "गलतियां",
    "back": "वापस",
    "lang": "ज़बान",
    "noData": "हलचा तक कांह डेटा नहीं",
    "loading": "लोड गछान...",
    "doAsk": "पूछो",
    "dontAsk": "न पूछो / कभनि न करो",
    "govOfIndia": "हिंदुस्तान सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "इंडियन साइबर क्राइम कोआर्डिनेशन सेंटर (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "साइबर जुर्म शिकायतुक आनलाइन दर्ज करनि खातर मुतास्सिरन/शिकायतगुज़ारन आसानी हिथ हिंदुस्तान सरकारुक इक कोशिश",
    "natlHelpline": "नेशनल हेल्पलाइन",
    "i4cCentre": "इंडियन साइबर क्राइम कोआर्डिनेशन सेंटर",
    "screenReader": "स्क्रीन रीडर एक्सेस",
    "marquee": "आनलाइन माली धोका-धड़ी रिपोर्ट करनि खातर, फ़ौरन नेशनल हेल्पलाइन 1930 पेठ फोन करो। फ़्रीज़ पैसु वापस हासिल करनुक इमकान बड़ावनि खातर साइबर जुर्म 24 घंटु अंदर रिपोर्ट करुन ज़रूरी छु। येह छु इक अंदरूनी ट्रेनिंग सिम्युलेटर — सिर्फ़ मस्नूई डेटा।"
  },
  "kok": {
    "appName": "१९३० प्रशिक्षण सिम्युलेटर",
    "appSub": "I4C कॉल घेवपी प्रशिक्षण",
    "badgeNumber": "बॅज क्रमांक",
    "password": "पासवर्ड",
    "login": "लॉगिन करचें",
    "loggingIn": "लॉग इन करप...",
    "signIn": "तुमच्या प्रशिक्षण खात्यांत सायन इन करात",
    "dashboard": "डॅशबोर्ड",
    "mcq": "परिस्थिती एमसीक्यू",
    "liveCall": "लायव्ह कॉल",
    "ncrpForm": "एनसीआरपी फॉर्म",
    "caseStudies": "केस स्टडीज",
    "reference": "संदर्भ मार्गदर्शक",
    "sop": "एसओपी मार्गदर्शक",
    "analytics": "विश्लेशणशास्त्र",
    "profile": "प्रोफायल",
    "users": "वापरपी वेवस्थापन",
    "adminDashboard": "प्रशासक अवलोकन",
    "logout": "लॉगआउट",
    "avgScore": "सरासरी गूण",
    "totalSessions": "सत्रां",
    "rank": "रँक",
    "topMistakes": "शीर्ष चुको",
    "quickStart": "बेगीन सुरू करप",
    "startTraining": "प्रशिक्षण सुरू करचें",
    "categoryProgress": "श्रेणी प्रगती",
    "welcome": "परत येवकार",
    "noMistakes": "अजून चुको नोंद जावंक नात — सराव चालू दवरात!",
    "difficulty": "अडचणीचें",
    "easy": "सोपे",
    "medium": "मध्यम",
    "hard": "कठीण",
    "start": "सुरू कर",
    "submit": "सादर करचें",
    "next": "फुडें",
    "correct": "बरोबर",
    "incorrect": "चुकीचें",
    "explanation": "विस्कटावणी",
    "yourScore": "तुमचो स्कोर",
    "finish": "सोंपोवचें",
    "review": "कॉला उपरांतची पुनरावलोकन",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "प्रस्न",
    "selectAnswer": "तुमची जाप वेंचून काडात",
    "scenarios": "परिस्थिती",
    "formNarrative": "कागाळ कथन",
    "validate": "प्रमाणीत करप & सादर करप",
    "commonMistake": "सामान्य चूक",
    "correctAnswer": "योग्य जाप",
    "yourEntry": "तुमची नोंद",
    "allCorrect": "सगळीं क्षेत्रां बरोबर!",
    "save": "बदल जतनाय घेवप",
    "editProfile": "प्रोफायल संपादीत करचें",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदलचें",
    "currentPassword": "सद्याचो पासवर्ड",
    "newPassword": "नवो पासवर्ड",
    "name": "नांव",
    "role": "भुमिका",
    "search": "सोद",
    "export": "निर्यात करप",
    "importUsers": "आयात वापरपी",
    "downloadTemplate": "डाउनलोड साचा",
    "delete": "काडून उडोवप",
    "makeAdmin": "एडमिन करात",
    "makeTrainee": "प्रशिक्षीत कर",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डावन",
    "trend": "क्रियाकलाप प्रवृत्ती",
    "createdAt": "रचलेले",
    "actions": "कृत्यां",
    "attempts": "प्रयत्न करतात",
    "lesson": "पाठ",
    "pattern": "निरिक्षण केल्लें नमुने",
    "searchTaxonomy": "गुन्यांव वर्ग सोदचें...",
    "txnFormat": "वेव्हार आयडी स्वरूप",
    "portal": "एनसीआरपी पोर्टल विभाग",
    "checklist": "तपासणी वळेरी",
    "importResult": "आयात परिणाम",
    "created": "रचलेले",
    "errors": "त्रुटी",
    "back": "फाटीं",
    "lang": "भास",
    "noData": "अजून डेटा ना",
    "loading": "लोड जावपाक लागलां...",
    "doAsk": "कर मागचें",
    "dontAsk": "विचारूं नाका / केन्नाच नाका",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "१९३० हेल्पलायन",
    "i4c": "भारतीय सायबर गुन्यांव समन्वय केंद्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "बळी / कागाळदारांक सायबर गुन्यांवांची कागाळी ऑनलायन कळोवपाची सुविधा दिवपा खातीर भारत सरकाराचो उपक्रम",
    "natlHelpline": "राष्ट्रीय मदतीची वेवस्था",
    "i4cCentre": "भारतीय सायबर गुन्यांव समन्वय केंद्र",
    "screenReader": "स्क्रीन रीडर प्रवेश",
    "marquee": "ऑनलायन अर्थीक फटवणूक कळोवपा खातीर, रोखडीच नॅशनल हेल्पलायन 1930 कडेन फोन करचो. गोठयल्ल्या निधीची चडांत चड वसुलीची संद मेळोवपा खातीर सायबर गुन्यांवांची म्हायती 24 वरां भितर दिवची पडटली. हो एक अंतर्गत प्रशिक्षण अनुकरण करपी आसा — फकत कृत्रीम डेटा."
  },
  "mai": {
    "appName": "1930 प्रशिक्षण सिम्युलेटर",
    "appSub": "I4C कॉल लेकर प्रशिक्षण",
    "badgeNumber": "बैज नंबर",
    "password": "पासवर्ड",
    "login": "लॉगिन",
    "loggingIn": "लॉग इन...",
    "signIn": "अपने प्रशिक्षण खाता में साइन इन करें",
    "dashboard": "डैशबोर्ड",
    "mcq": "परिदृश्य एमसीक्यू",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी फॉर्म",
    "caseStudies": "केस स्टडीज",
    "reference": "सन्दर्भ मार्गदर्शिका",
    "sop": "एसओपी गाइड",
    "analytics": "विश्लेषणात्मकता",
    "profile": "प्रोफाइल",
    "users": "प्रयोक्ता प्रबंधन",
    "adminDashboard": "एडमिन अवलोकन",
    "logout": "लॉगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्र",
    "rank": "रैंक",
    "topMistakes": "टॉप गलतियाँ",
    "quickStart": "त्वरित प्रारंभ",
    "startTraining": "प्रशिक्षण शुरू करे",
    "categoryProgress": "श्रेणी प्रगति",
    "welcome": "वापस स्वागत अछि",
    "noMistakes": "एखन धरि कोनो गलती दर्ज नहि भेल अछि — अभ्यास करैत रहू !",
    "difficulty": "कठिनाई",
    "easy": "आसान",
    "medium": "मध्यम",
    "hard": "कठिन",
    "start": "शुरू करू",
    "submit": "जमा करू",
    "next": "अगला",
    "correct": "सही",
    "incorrect": "गलत",
    "explanation": "व्याख्या",
    "yourScore": "अपने स्कोर",
    "finish": "खतम करु",
    "review": "कॉल के बाद समीक्षा",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "प्रश्न",
    "selectAnswer": "अपन जवाब चुनू",
    "scenarios": "परिदृश्य",
    "formNarrative": "शिकायत कथ्य",
    "validate": "मान्य एवं जमा करे",
    "commonMistake": "आम गलती",
    "correctAnswer": "सही उत्तर",
    "yourEntry": "अहाँक प्रविष्टि",
    "allCorrect": "सब क्षेत्र सही अछि!",
    "save": "परिवर्तन सहेजें",
    "editProfile": "प्रोफाइल संपादित करू",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदलें",
    "currentPassword": "वर्तमान पासवर्ड",
    "newPassword": "नया पासवर्ड",
    "name": "नाम",
    "role": "भूमिका",
    "search": "खोज",
    "export": "निर्यात",
    "importUsers": "आयात उपयोगकर्ता",
    "downloadTemplate": "डाउनलोड टेम्पलेट",
    "delete": "मेटाउ",
    "makeAdmin": "एडमिन बनाओ",
    "makeTrainee": "प्रशिक्षु बनाओ",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "गतिविधि प्रवृत्ति",
    "createdAt": "रचल गेल",
    "actions": "कर्म",
    "attempts": "प्रयास",
    "lesson": "पाठ",
    "pattern": "अवलोकन पैटर्न",
    "searchTaxonomy": "अपराध श्रेणियाँ खोजें...",
    "txnFormat": "लेनदेन आईडी प्रारूप",
    "portal": "एनसीआरपी पोर्टल अनुभाग",
    "checklist": "चेकलिस्ट",
    "importResult": "आयात परिणाम",
    "created": "रचल गेल",
    "errors": "त्रुटियाँ",
    "back": "वापस",
    "lang": "भाषा",
    "noData": "एखन धरि कोनो डाटा नहि",
    "loading": "लोड हो रहल अछि...",
    "doAsk": "कर पूछ",
    "dontAsk": "नै पूछू / कहियो नै करू",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "भारतीय साइबर अपराध समन्वय केन्द्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "पीड़ित / शिकायतकर्ता के साइबर अपराध के शिकायत के ऑनलाइन रिपोर्ट करय में सुविधा के लेल भारत सरकार के एकटा पहल",
    "natlHelpline": "राष्ट्रीय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केन्द्र",
    "screenReader": "स्क्रीन रीडर पहुँच",
    "marquee": "ऑनलाइन वित्तीय धोखाधड़ी कें रिपोर्टिंग कें लेल, तुरंत राष्ट्रीय हेल्पलाइन 1930 पर फोन करूं. जमे हुए धनराशि कें वसूली कें संभावना कें अधिकतम करय कें लेल साइबर अपराध कें 24 घंटा कें भीतर रिपोर्ट करनाय आवश्यक छै. इ एकटा आंतरिक प्रशिक्षण सिम्युलेटर छै — केवल सिंथेटिक डाटा."
  },
  "ml": {
    "appName": "1930 പരിശീലന സിമുലേറ്റർ",
    "appSub": "I4C കോൾ ടേക്കർ ട്രെയിനിംഗ്",
    "badgeNumber": "ബാഡ്ജ് നമ്പർ",
    "password": "പാസ്‌വേഡ്",
    "login": "ലോഗിൻ",
    "loggingIn": "ലോഗിൻ ചെയ്യുന്നു...",
    "signIn": "നിങ്ങളുടെ പരിശീലന അക്കൗണ്ടിലേക്ക് സൈൻ ഇൻ ചെയ്യുക",
    "dashboard": "ഡാഷ്ബോർഡ്",
    "mcq": "രംഗം MCQ",
    "liveCall": "ലൈവ് കോൾ",
    "ncrpForm": "NCRP ഫോം",
    "caseStudies": "കേസ് സ്റ്റഡീസ്",
    "reference": "റഫറൻസ് ഗൈഡ്",
    "sop": "SOP ഗൈഡ്",
    "analytics": "അനലിറ്റിക്സ്",
    "profile": "പ്രൊഫൈൽ",
    "users": "ഉപയോക്തൃ മാനേജ്മെൻ്റ്",
    "adminDashboard": "അഡ്മിൻ അവലോകനം",
    "logout": "ലോഗ്ഔട്ട്",
    "avgScore": "ശരാശരി സ്കോർ",
    "totalSessions": "സെഷനുകൾ",
    "rank": "റാങ്ക്",
    "topMistakes": "പ്രധാന തെറ്റുകൾ",
    "quickStart": "ദ്രുത തുടക്കം",
    "startTraining": "പരിശീലനം ആരംഭിക്കുക",
    "categoryProgress": "വിഭാഗം പുരോഗതി",
    "welcome": "തിരികെ സ്വാഗതം",
    "noMistakes": "ഇതുവരെ പിശകുകളൊന്നും രേഖപ്പെടുത്തിയിട്ടില്ല - പരിശീലിക്കുന്നത് തുടരുക!",
    "difficulty": "ബുദ്ധിമുട്ട്",
    "easy": "എളുപ്പം",
    "medium": "ഇടത്തരം",
    "hard": "ഹാർഡ്",
    "start": "ആരംഭിക്കുക",
    "submit": "സമർപ്പിക്കുക",
    "next": "അടുത്തത്",
    "correct": "ശരി",
    "incorrect": "തെറ്റാണ്",
    "explanation": "വിശദീകരണം",
    "yourScore": "നിങ്ങളുടെ സ്കോർ",
    "finish": "പൂർത്തിയാക്കുക",
    "review": "പോസ്റ്റ്-കോൾ അവലോകനം",
    "callScript": "കോൾ സ്ക്രിപ്റ്റ്",
    "question": "ചോദ്യം",
    "selectAnswer": "നിങ്ങളുടെ ഉത്തരം തിരഞ്ഞെടുക്കുക",
    "scenarios": "സാഹചര്യങ്ങൾ",
    "formNarrative": "പരാതി വിവരണം",
    "validate": "സാധൂകരിക്കുകയും സമർപ്പിക്കുകയും ചെയ്യുക",
    "commonMistake": "സാധാരണ തെറ്റ്",
    "correctAnswer": "ശരിയായ ഉത്തരം",
    "yourEntry": "നിങ്ങളുടെ എൻട്രി",
    "allCorrect": "എല്ലാ ഫീൽഡുകളും ശരിയാണ്!",
    "save": "മാറ്റങ്ങൾ സംരക്ഷിക്കുക",
    "editProfile": "പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
    "designation": "പദവി",
    "state": "സംസ്ഥാനം",
    "changePassword": "പാസ്‌വേഡ് മാറ്റുക",
    "currentPassword": "നിലവിലെ പാസ്‌വേഡ്",
    "newPassword": "പുതിയ പാസ്‌വേഡ്",
    "name": "പേര്",
    "role": "പങ്ക്",
    "search": "തിരയുക",
    "export": "കയറ്റുമതി",
    "importUsers": "ഉപയോക്താക്കളെ ഇറക്കുമതി ചെയ്യുക",
    "downloadTemplate": "ടെംപ്ലേറ്റ് ഡൗൺലോഡ് ചെയ്യുക",
    "delete": "ഇല്ലാതാക്കുക",
    "makeAdmin": "അഡ്മിൻ ആക്കുക",
    "makeTrainee": "ട്രെയിനി ഉണ്ടാക്കുക",
    "leaderboard": "ലീഡർബോർഡ്",
    "categoryDistribution": "വിഭാഗം വിതരണം",
    "stateDrilldown": "സംസ്ഥാന ഡ്രിൽ-ഡൗൺ",
    "trend": "പ്രവർത്തന പ്രവണത",
    "createdAt": "സൃഷ്ടിച്ചത്",
    "actions": "പ്രവർത്തനങ്ങൾ",
    "attempts": "ശ്രമങ്ങൾ",
    "lesson": "പാഠം",
    "pattern": "നിരീക്ഷിച്ച പാറ്റേൺ",
    "searchTaxonomy": "കുറ്റകൃത്യ വിഭാഗങ്ങൾ തിരയുക...",
    "txnFormat": "ഇടപാട് ഐഡി ഫോർമാറ്റ്",
    "portal": "NCRP പോർട്ടൽ വിഭാഗം",
    "checklist": "ചെക്ക്‌ലിസ്റ്റ്",
    "importResult": "ഇറക്കുമതി ഫലം",
    "created": "സൃഷ്ടിച്ചത്",
    "errors": "പിശകുകൾ",
    "back": "തിരികെ",
    "lang": "ഭാഷ",
    "noData": "ഇതുവരെ ഡാറ്റയില്ല",
    "loading": "ലോഡ് ചെയ്യുന്നു...",
    "doAsk": "ചോദിക്കൂ",
    "dontAsk": "ചോദിക്കരുത് / ഒരിക്കലും ചെയ്യരുത്",
    "govOfIndia": "ഇന്ത്യാ ഗവൺമെൻ്റ്",
    "mha": "ആഭ്യന്തര മന്ത്രാലയം",
    "helpline": "1930 ഹെൽപ്പ് ലൈൻ",
    "i4c": "ഇന്ത്യൻ സൈബർ ക്രൈം കോർഡിനേഷൻ സെൻ്റർ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "സൈബർ ക്രൈം പരാതികൾ ഓൺലൈനായി റിപ്പോർട്ട് ചെയ്യാൻ ഇരകൾക്കും പരാതിക്കാർക്കും സൗകര്യമൊരുക്കുന്നതിനുള്ള ഒരു ഇന്ത്യാ ഗവൺമെൻ്റ് സംരംഭം",
    "natlHelpline": "ദേശീയ ഹെൽപ്ലൈൻ",
    "i4cCentre": "ഇന്ത്യൻ സൈബർ ക്രൈം കോർഡിനേഷൻ സെൻ്റർ",
    "screenReader": "സ്ക്രീൻ റീഡർ ആക്സസ്",
    "marquee": "ഓൺലൈൻ സാമ്പത്തിക തട്ടിപ്പ് റിപ്പോർട്ട് ചെയ്യാൻ, ഉടൻ ദേശീയ ഹെൽപ്പ്‌ലൈൻ 1930-ൽ വിളിക്കുക. മരവിപ്പിച്ച ഫണ്ടുകൾ വീണ്ടെടുക്കാനുള്ള സാധ്യത വർദ്ധിപ്പിക്കാൻ സൈബർ കുറ്റകൃത്യങ്ങൾ 24 മണിക്കൂറിനുള്ളിൽ റിപ്പോർട്ട് ചെയ്യണം. ഇത് ഒരു ആന്തരിക പരിശീലന സിമുലേറ്റർ ആണ് — സിന്തറ്റിക് ഡാറ്റ മാത്രം."
  },
  "mni": {
    "appName": "১৯৩০ ৱাহেংগী শিমুলেতর",
    "appSub": "I4C কল তেকর ৱাহেং",
    "badgeNumber": "বেজ নম্বর",
    "password": "পাসৱার্দ",
    "login": "লোগিন",
    "loggingIn": "লোগিন তৌরি...",
    "signIn": "নহাক্কী ৱাহেংগী একাউন্ত সাইন ইন তৌবিয়ু",
    "dashboard": "দেসবোর্দ",
    "mcq": "সিনারিও MCQ",
    "liveCall": "লাইব কল",
    "ncrpForm": "NCRP ফোরম",
    "caseStudies": "কেস স্তাদীস",
    "reference": "রেফরেন্স গাইদ",
    "sop": "SOP গাইদ",
    "analytics": "এনালিতিক্স",
    "profile": "প্রোফাইল",
    "users": "য়ুজর মেনেজমেন্ত",
    "adminDashboard": "এদমিন ওভরভিউ",
    "logout": "লোগআউত",
    "avgScore": "এবারেজ স্কোর",
    "totalSessions": "সেসন",
    "rank": "রেঙ্ক",
    "topMistakes": "অহানবা অশোয়বা",
    "quickStart": "থুনামক হৌবা",
    "startTraining": "ৱাহেং হৌবিয়ু",
    "categoryProgress": "কেতেগোরিগী ওইনবা",
    "welcome": "অমুক লক্লবা তরাম্না উরে",
    "noMistakes": "হৌজিক্তৃ অশোয়বা কয়া থিদ্রে — চহি চহি লৌরগা লৈরু!",
    "difficulty": "কায়দাবা",
    "easy": "লাইবা",
    "medium": "মদিয়ম",
    "hard": "কায়দাবা",
    "start": "হৌবা",
    "submit": "সবমিত তৌবা",
    "next": "মথং",
    "correct": "চুম্মি",
    "incorrect": "অশোয়বা",
    "explanation": "শোংদোকপা",
    "yourScore": "নহাক্কী স্কোর",
    "finish": "লোয়সিনবা",
    "review": "কল তৌরবগী মতুংদা য়েংশিনবা",
    "callScript": "কল স্ক্রিপ্ত",
    "question": "ৱাহং",
    "selectAnswer": "নহাক্কী পাউখুম খল্লু",
    "scenarios": "সিনারিওশিং",
    "formNarrative": "ৱারেপ্লাইন্ত",
    "validate": "চেকশিন্নবা অমসুং সবমিত তৌবা",
    "commonMistake": "য়াম্না থোকপা অশোয়বা",
    "correctAnswer": "চুম্মী পাউখুম",
    "yourEntry": "নহাক্কী এন্ত্রি",
    "allCorrect": "ফিল্দ পুম্নমক চুম্মি!",
    "save": "হোংদোকপা সীব",
    "editProfile": "প্রোফাইল শেমদোকপা",
    "designation": "থৌদাং",
    "state": "স্তেত",
    "changePassword": "পাসৱার্দ হোংদোকপা",
    "currentPassword": "হৌজিক্কী পাসৱার্দ",
    "newPassword": "অনৌবা পাসৱার্দ",
    "name": "মমিং",
    "role": "থৌদাং",
    "search": "থিবা",
    "export": "একস্পোর্ত",
    "importUsers": "য়ুজরশিং ইম্পোর্ত তৌবা",
    "downloadTemplate": "তেম্প্লেত দাউনলোদ তৌবা",
    "delete": "লেয়থোকপা",
    "makeAdmin": "এদমিন ওইহনবা",
    "makeTrainee": "ত্রেনি ওইহনবা",
    "leaderboard": "লিদরবোর্দ",
    "categoryDistribution": "কেতেগোরি য়েনথোকপা",
    "stateDrilldown": "স্তেত দ্রিল-দাউন",
    "trend": "থৌরাংগী তেন্দেন্সি",
    "createdAt": "শেম্লবা",
    "actions": "থবক",
    "attempts": "হোৎনবা",
    "lesson": "তম্বীৰোল",
    "pattern": "য়েংখৎলবা মথৌ",
    "searchTaxonomy": "ফত্তবগী কেতেগোরি থিয়ু...",
    "txnFormat": "ত্রান্জেক্সন ID ফোরমেত",
    "portal": "NCRP পোর্তেল সেক্সন",
    "checklist": "চেকলিস্ত",
    "importResult": "ইম্পোর্ত মরি",
    "created": "শেম্লবা",
    "errors": "অশোয়বাশিং",
    "back": "হনবা",
    "lang": "লোল",
    "noData": "হৌজিক্তৃ দাতা লৈত্রে",
    "loading": "লোদ তৌরি...",
    "doAsk": "হংগু",
    "dontAsk": "হংদনা / নত্তে অমত্তা তৌদনা",
    "govOfIndia": "ভারত সরকার",
    "mha": "নহারোলগী মন্ত্রালয়",
    "helpline": "১৯৩০ হেল্পলাইন",
    "i4c": "ইন্দিয়ান সাইবর ক্রাইম কোওর্দিনেসন সেন্তর (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "সাইবর ক্রাইমগী ৱারেপ পুম্নমক অনলাইন্দা রিপোর্ত তৌবা য়াবা মথৌ পাংথোকপগীদমক ভারত সরকারগী থবক অমা",
    "natlHelpline": "নেসনেল হেল্পলাইন",
    "i4cCentre": "ইন্দিয়ান সাইবর ক্রাইম কোওর্দিনেসন সেন্তর",
    "screenReader": "স্ক্রিন রিদর একসেস",
    "marquee": "অনলাইন ফাইনেন্সিয়েল ফ্রদগী রিপোর্ত তৌনবা, খুদক্তগী নেসনেল হেল্পলাইন ১৯৩০দা কল তৌবিয়ু। ফ্রিজ তৌরবা সেল হাপচিনবগী মওং য়াম্না হেংবা য়াহনবগীদমক সাইবর ক্রাইমশিং পুং ২৪গী মনুংদা রিপোর্ত তৌগদবনি। মসি ৱাহেংগী শিমুলেতর অমনি — সিন্থেতিক দাতা খক্তনি।"
  },
  "mr": {
    "appName": "1930 प्रशिक्षण सिम्युलेटर",
    "appSub": "I4C कॉल टेकर ट्रेनिंग",
    "badgeNumber": "बॅज क्रमांक",
    "password": "पासवर्ड",
    "login": "लॉग इन",
    "loggingIn": "लॉग इन करत आहे...",
    "signIn": "तुमच्या प्रशिक्षण खात्यात साइन इन करा",
    "dashboard": "डॅशबोर्ड",
    "mcq": "परिस्थिती MCQ",
    "liveCall": "थेट कॉल",
    "ncrpForm": "NCRP फॉर्म",
    "caseStudies": "केस स्टडीज",
    "reference": "संदर्भ मार्गदर्शक",
    "sop": "SOP मार्गदर्शक",
    "analytics": "विश्लेषण",
    "profile": "प्रोफाइल",
    "users": "वापरकर्ता व्यवस्थापन",
    "adminDashboard": "प्रशासन विहंगावलोकन",
    "logout": "लॉगआउट",
    "avgScore": "सरासरी स्कोअर",
    "totalSessions": "सत्रे",
    "rank": "रँक",
    "topMistakes": "शीर्ष चुका",
    "quickStart": "द्रुत सुरुवात",
    "startTraining": "प्रशिक्षण सुरू करा",
    "categoryProgress": "श्रेणी प्रगती",
    "welcome": "परत स्वागत आहे",
    "noMistakes": "अद्याप कोणत्याही चुका नोंदवल्या नाहीत — सराव सुरू ठेवा!",
    "difficulty": "अडचण",
    "easy": "सोपे",
    "medium": "मध्यम",
    "hard": "कठीण",
    "start": "सुरू करा",
    "submit": "सबमिट करा",
    "next": "पुढे",
    "correct": "बरोबर",
    "incorrect": "चुकीचे",
    "explanation": "स्पष्टीकरण",
    "yourScore": "तुमचा स्कोअर",
    "finish": "समाप्त करा",
    "review": "कॉल नंतरचे पुनरावलोकन",
    "callScript": "कॉल स्क्रिप्ट",
    "question": "प्रश्न",
    "selectAnswer": "तुमचे उत्तर निवडा",
    "scenarios": "परिस्थिती",
    "formNarrative": "तक्रार कथन",
    "validate": "सत्यापित करा आणि सबमिट करा",
    "commonMistake": "सामान्य चूक",
    "correctAnswer": "बरोबर उत्तर",
    "yourEntry": "तुमची एंट्री",
    "allCorrect": "सर्व फील्ड बरोबर!",
    "save": "बदल जतन करा",
    "editProfile": "प्रोफाइल संपादित करा",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड बदला",
    "currentPassword": "सध्याचा पासवर्ड",
    "newPassword": "नवीन पासवर्ड",
    "name": "नाव",
    "role": "भूमिका",
    "search": "शोधा",
    "export": "निर्यात करा",
    "importUsers": "वापरकर्ते आयात करा",
    "downloadTemplate": "साचा डाउनलोड करा",
    "delete": "हटवा",
    "makeAdmin": "Admin करा",
    "makeTrainee": "प्रशिक्षणार्थी बनवा",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "क्रियाकलाप कल",
    "createdAt": "निर्माण केले",
    "actions": "कृती",
    "attempts": "प्रयत्न",
    "lesson": "धडा",
    "pattern": "निरीक्षण नमुना",
    "searchTaxonomy": "गुन्ह्यांच्या श्रेणी शोधा...",
    "txnFormat": "ट्रान्झॅक्शन आयडी फॉरमॅट",
    "portal": "NCRP पोर्टल विभाग",
    "checklist": "चेकलिस्ट",
    "importResult": "परिणाम आयात करा",
    "created": "निर्माण केले",
    "errors": "चुका",
    "back": "मागे",
    "lang": "भाषा",
    "noData": "अजून डेटा नाही",
    "loading": "लोड करत आहे...",
    "doAsk": "विचारा",
    "dontAsk": "विचारू नका/कधी करू नका",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "भारतीय सायबर गुन्हे समन्वय केंद्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "सायबर गुन्ह्यांच्या तक्रारींची ऑनलाइन तक्रार करण्यासाठी पीडित / तक्रारदारांना सुविधा देण्यासाठी भारत सरकारचा पुढाकार",
    "natlHelpline": "नॅशनल हेल्पलाइन",
    "i4cCentre": "भारतीय सायबर गुन्हे समन्वय केंद्र",
    "screenReader": "स्क्रीन रीडर ऍक्सेस",
    "marquee": "ऑनलाइन आर्थिक फसवणुकीची तक्रार करण्यासाठी, राष्ट्रीय हेल्पलाइन 1930 वर त्वरित कॉल करा. गोठवलेल्या निधीच्या पुनर्प्राप्तीची शक्यता वाढवण्यासाठी 24 तासांच्या आत सायबर गुन्ह्यांची नोंद करणे आवश्यक आहे. हे अंतर्गत प्रशिक्षण सिम्युलेटर आहे — केवळ सिंथेटिक डेटा."
  },
  "ne": {
    "appName": "1930 प्रशिक्षण सिम्युलेटर",
    "appSub": "I4C कल टेकर प्रशिक्षण",
    "badgeNumber": "ब्याज नम्बर",
    "password": "पासवर्ड",
    "login": "लगइन",
    "loggingIn": "लग इन गर्दै...",
    "signIn": "आफ्नो प्रशिक्षण खातामा साइन इन गर्नुहोस्",
    "dashboard": "ड्यासबोर्ड",
    "mcq": "परिदृश्य MCQ",
    "liveCall": "लाइभ कल",
    "ncrpForm": "NCRP फारम",
    "caseStudies": "केस स्टडीज",
    "reference": "सन्दर्भ गाइड",
    "sop": "SOP गाइड",
    "analytics": "विश्लेषण",
    "profile": "प्रोफाइल",
    "users": "प्रयोगकर्ता व्यवस्थापन",
    "adminDashboard": "प्रशासन सिंहावलोकन",
    "logout": "लगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्रहरु",
    "rank": "श्रेणी",
    "topMistakes": "शीर्ष गल्तीहरु",
    "quickStart": "द्रुत सुरुवात",
    "startTraining": "तालिम सुरु गर्नुहोस्",
    "categoryProgress": "श्रेणी प्रगति",
    "welcome": "फेरि स्वागत छ",
    "noMistakes": "अहिलेसम्म कुनै गल्तीहरू रेकर्ड गरिएको छैन - अभ्यास जारी राख्नुहोस्!",
    "difficulty": "कठिनाई",
    "easy": "सजिलो",
    "medium": "मध्यम",
    "hard": "कठिन",
    "start": "सुरु",
    "submit": "पेश गर्नुहोस्",
    "next": "अर्को",
    "correct": "सहि",
    "incorrect": "गलत",
    "explanation": "व्याख्या",
    "yourScore": "तपाईको स्कोर",
    "finish": "समाप्त गर्नुहोस्",
    "review": "पोस्ट-कल समीक्षा",
    "callScript": "कल स्क्रिप्ट",
    "question": "प्रश्न",
    "selectAnswer": "आफ्नो उत्तर छान्नुहोस्",
    "scenarios": "परिदृश्यहरु",
    "formNarrative": "गुनासो कथा",
    "validate": "मान्य र पेश गर्नुहोस्",
    "commonMistake": "साधारण गल्ती",
    "correctAnswer": "सहि उत्तर",
    "yourEntry": "तपाईको प्रवेश",
    "allCorrect": "सबै क्षेत्रहरू सही!",
    "save": "परिवर्तनहरू बचत गर्नुहोस्",
    "editProfile": "प्रोफाइल सम्पादन गर्नुहोस्",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "पासवर्ड परिवर्तन गर्नुहोस्",
    "currentPassword": "हालको पासवर्ड",
    "newPassword": "नयाँ पासवर्ड",
    "name": "नाम",
    "role": "भूमिका",
    "search": "खोजी",
    "export": "निर्यात",
    "importUsers": "प्रयोगकर्ता आयात गर्नुहोस्",
    "downloadTemplate": "टेम्प्लेट डाउनलोड गर्नुहोस्",
    "delete": "मेट्नुहोस्",
    "makeAdmin": "Admin बनाउनुहोस्",
    "makeTrainee": "ट्रेनी बनाउनुहोस्",
    "leaderboard": "लिडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "गतिविधि प्रवृत्ति",
    "createdAt": "सिर्जना गरियो",
    "actions": "कार्यहरु",
    "attempts": "प्रयास",
    "lesson": "पाठ",
    "pattern": "अवलोकन गरिएको ढाँचा",
    "searchTaxonomy": "अपराध कोटिहरु खोज्नुहोस्...",
    "txnFormat": "लेनदेन आईडी ढाँचा",
    "portal": "NCRP पोर्टल खण्ड",
    "checklist": "चेकलिस्ट",
    "importResult": "आयात परिणाम",
    "created": "सिर्जना गरियो",
    "errors": "त्रुटिहरु",
    "back": "फिर्ता",
    "lang": "भाषा",
    "noData": "अहिलेसम्म कुनै डाटा छैन",
    "loading": "लोड हुँदै...",
    "doAsk": "सोध्नुहोस्",
    "dontAsk": "नसोध्नु/कहिल्यै नगर्नुहोस्",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मन्त्रालय",
    "helpline": "1930 हेल्पलाइन",
    "i4c": "भारतीय साइबर अपराध समन्वय केन्द्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "साइबर अपराध सम्बन्धी उजुरीहरू अनलाइन रिपोर्ट गर्न पीडित/उजुरीकर्तालाई सहज बनाउन भारत सरकारको पहल",
    "natlHelpline": "राष्ट्रिय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केन्द्र",
    "screenReader": "स्क्रिन रिडर पहुँच",
    "marquee": "अनलाइन वित्तीय ठगी रिपोर्ट गर्नको लागि, राष्ट्रिय हेल्पलाइन 1930 लाई तुरुन्तै कल गर्नुहोस्। फ्रिज गरिएको रकमको रिकभरी संभावनाहरू अधिकतम गर्न साइबर अपराधहरू 24 घण्टा भित्र रिपोर्ट गरिनुपर्छ। यो एक आन्तरिक प्रशिक्षण सिम्युलेटर हो — सिंथेटिक डेटा मात्र।"
  },
  "or": {
    "appName": "1930 ଟ୍ରେନିଂ ସିମୁଲେଟର",
    "appSub": "I4C କଲ୍ ଟେକର୍ ଟ୍ରେନିଂ",
    "badgeNumber": "ବ୍ୟାଜ୍ ସଂଖ୍ୟା",
    "password": "ପାସୱାର୍ଡ",
    "login": "ଲଗଇନ୍",
    "loggingIn": "ଲଗ୍ ଇନ୍ ...",
    "signIn": "ତୁମର ଟ୍ରେନିଂ ଆକାଉଣ୍ଟକୁ ସାଇନ୍ ଇନ୍ କର",
    "dashboard": "ଡ୍ୟାସବୋର୍ଡ",
    "mcq": "ଦୃଶ୍ୟ MCQ",
    "liveCall": "ଲାଇଭ୍ କଲ୍",
    "ncrpForm": "NCRP ଫର୍ମ",
    "caseStudies": "କେସ୍ ଷ୍ଟଡିଜ୍",
    "reference": "ସନ୍ଦର୍ଭ ଗାଇଡ୍",
    "sop": "SOP ଗାଇଡ୍",
    "analytics": "ଆନାଲିଟିକ୍ସ",
    "profile": "ପ୍ରୋଫାଇଲ୍",
    "users": "ଉପଯୋଗକର୍ତ୍ତା ପରିଚାଳନା",
    "adminDashboard": "ଆଡମିନି ସମୀକ୍ଷା",
    "logout": "ଲଗଆଉଟ୍",
    "avgScore": "ହାରାହାରି ସ୍କୋର",
    "totalSessions": "ଅଧିବେଶନ",
    "rank": "ରାଙ୍କ୍",
    "topMistakes": "ଶୀର୍ଷ ତ୍ରୁଟି",
    "quickStart": "ଶୀଘ୍ର ଆରମ୍ଭ",
    "startTraining": "ତାଲିମ ଆରମ୍ଭ",
    "categoryProgress": "ବର୍ଗ ପ୍ରଗତି",
    "welcome": "ପୁନର୍ବାର ସ୍ୱାଗତ",
    "noMistakes": "ଏପର୍ଯ୍ୟନ୍ତ କ mistakes ଣସି ତ୍ରୁଟି ରେକର୍ଡ ହୋଇନାହିଁ - ଅଭ୍ୟାସ ଜାରି ରଖ!",
    "difficulty": "ଅସୁବିଧା",
    "easy": "ସହଜ",
    "medium": "ମଧ୍ୟମ",
    "hard": "କଠିନ",
    "start": "ଆରମ୍ଭ",
    "submit": "ଦାଖଲ",
    "next": "ପରବର୍ତ୍ତୀ",
    "correct": "ସଠିକ୍",
    "incorrect": "ଭୁଲ",
    "explanation": "ବ୍ୟାଖ୍ୟା",
    "yourScore": "ତୁମର ସ୍କୋର",
    "finish": "ସମାପ୍ତ",
    "review": "କଲ-ପରବର୍ତ୍ତୀ ସମୀକ୍ଷା",
    "callScript": "କଲ୍ ସ୍କ୍ରିପ୍ଟ",
    "question": "ପ୍ରଶ୍ନ",
    "selectAnswer": "ଆପଣଙ୍କର ଉତ୍ତର ଚୟନ କରନ୍ତୁ",
    "scenarios": "ଦୃଶ୍ୟ",
    "formNarrative": "ଅଭିଯୋଗ କାହାଣୀ",
    "validate": "ବ id ଧ ଏବଂ ଦାଖଲ",
    "commonMistake": "ସାଧାରଣ ତ୍ରୁଟି",
    "correctAnswer": "ସଠିକ୍ ଉତ୍ତର",
    "yourEntry": "ତୁମର ଏଣ୍ଟ୍ରି",
    "allCorrect": "ସମସ୍ତ କ୍ଷେତ୍ର ସଠିକ୍!",
    "save": "ପରିବର୍ତ୍ତନଗୁଡିକ ସଞ୍ଚୟ କରନ୍ତୁ",
    "editProfile": "ପ୍ରୋଫାଇଲ୍ ସଂପାଦନ କରନ୍ତୁ",
    "designation": "ପଦବୀ",
    "state": "ରାଜ୍ୟ",
    "changePassword": "ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
    "currentPassword": "ସାମ୍ପ୍ରତିକ ପାସୱାର୍ଡ",
    "newPassword": "ନୂତନ ପାସୱାର୍ଡ",
    "name": "ନାମ",
    "role": "ଭୂମିକା",
    "search": "ସନ୍ଧାନ",
    "export": "ରପ୍ତାନି",
    "importUsers": "ବ୍ୟବହାରକାରୀଙ୍କୁ ଆମଦାନି କରନ୍ତୁ",
    "downloadTemplate": "ଟେମ୍ପଲେଟ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ",
    "delete": "ବିଲୋପ କରନ୍ତୁ",
    "makeAdmin": "ଆଡମିନି ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "makeTrainee": "ପ୍ରଶିକ୍ଷକ ପ୍ରସ୍ତୁତ କରନ୍ତୁ",
    "leaderboard": "ଲିଡବୋର୍ଡ",
    "categoryDistribution": "ବର୍ଗ ବଣ୍ଟନ",
    "stateDrilldown": "ରାଜ୍ୟ ଡ୍ରିଲ୍ ଡାଉନ୍",
    "trend": "କାର୍ଯ୍ୟକଳାପ ଧାରା",
    "createdAt": "ସୃଷ୍ଟି",
    "actions": "କାର୍ଯ୍ୟ",
    "attempts": "ପ୍ରୟାସ",
    "lesson": "ଶିକ୍ଷା",
    "pattern": "ପର୍ଯ୍ୟବେକ୍ଷଣ ପାଟର୍ନ",
    "searchTaxonomy": "ଅପରାଧ ବର୍ଗ ଖୋଜ ...",
    "txnFormat": "କାରବାର ID ଫର୍ମାଟ୍",
    "portal": "NCRP ପୋର୍ଟାଲ୍ ବିଭାଗ",
    "checklist": "ଯାଞ୍ଚ ତାଲିକା",
    "importResult": "ଆମଦାନି ଫଳାଫଳ",
    "created": "ସୃଷ୍ଟି",
    "errors": "ତ୍ରୁଟି",
    "back": "ପଛକୁ",
    "lang": "ଭାଷା",
    "noData": "ଏପର୍ଯ୍ୟନ୍ତ କ data ଣସି ତଥ୍ୟ ନାହିଁ",
    "loading": "ଲୋଡିଂ ...",
    "doAsk": "ପଚାର",
    "dontAsk": "ପଚାରନ୍ତୁ ନାହିଁ / କେବେ କରନ୍ତୁ ନାହିଁ",
    "govOfIndia": "ଭାରତ ସରକାର",
    "mha": "ଗୃହ ମନ୍ତ୍ରଣାଳୟ",
    "helpline": "1930 ହେଲ୍ପଲାଇନ",
    "i4c": "ଭାରତୀୟ ସାଇବର ଅପରାଧ ସମନ୍ୱୟ କେନ୍ଦ୍ର (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "ପୀଡିତ / ଅଭିଯୋଗକାରୀଙ୍କୁ ଅନଲାଇନରେ ସାଇବର ଅପରାଧ ଅଭିଯୋଗ ରିପୋର୍ଟ କରିବାକୁ ସହଜ କରିବାକୁ ଭାରତ ସରକାରଙ୍କ ପଦକ୍ଷେପ",
    "natlHelpline": "ଜାତୀୟ ସହାୟତା",
    "i4cCentre": "ଭାରତୀୟ ସାଇବର ଅପରାଧ ସମନ୍ୱୟ କେନ୍ଦ୍ର",
    "screenReader": "ସ୍କ୍ରିନ୍ ରିଡର୍ ଆକ୍ସେସ୍",
    "marquee": "ଅନଲାଇନ୍ ଆର୍ଥିକ ଜାଲିଆତି ରିପୋର୍ଟ କରିବା ପାଇଁ ତୁରନ୍ତ ନ୍ୟାସନାଲ ହେଲ୍ପଲାଇନ 1930 କୁ କଲ କରନ୍ତୁ | ଫ୍ରିଜ୍ ପାଣ୍ଠିର ପୁନରୁଦ୍ଧାର ସମ୍ଭାବନାକୁ ବ imize ାଇବା ପାଇଁ ସାଇବର ଅପରାଧ 24 ଘଣ୍ଟା ମଧ୍ୟରେ ରିପୋର୍ଟ କରାଯିବା ଆବଶ୍ୟକ | ଏହା ଏକ ଆଭ୍ୟନ୍ତରୀଣ ତାଲିମ ସିମୁଲେଟର - କେବଳ ସିନ୍ଥେଟିକ୍ ତଥ୍ୟ |"
  },
  "pa": {
    "appName": "1930 ਸਿਖਲਾਈ ਸਿਮੂਲੇਟਰ",
    "appSub": "I4C ਕਾਲ ਟੇਕਰ ਟ੍ਰੇਨਿੰਗ",
    "badgeNumber": "ਬੈਜ ਨੰਬਰ",
    "password": "ਪਾਸਵਰਡ",
    "login": "ਲਾਗਇਨ",
    "loggingIn": "ਲੌਗ ਇਨ...",
    "signIn": "ਆਪਣੇ ਸਿਖਲਾਈ ਖਾਤੇ ਵਿੱਚ ਸਾਈਨ ਇਨ ਕਰੋ",
    "dashboard": "ਡੈਸ਼ਬੋਰਡ",
    "mcq": "ਦ੍ਰਿਸ਼ MCQ",
    "liveCall": "ਲਾਈਵ ਕਾਲ",
    "ncrpForm": "NCRP ਫਾਰਮ",
    "caseStudies": "ਕੇਸ ਸਟੱਡੀਜ਼",
    "reference": "ਹਵਾਲਾ ਗਾਈਡ",
    "sop": "SOP ਗਾਈਡ",
    "analytics": "ਵਿਸ਼ਲੇਸ਼ਣ",
    "profile": "ਪ੍ਰੋਫਾਈਲ",
    "users": "ਉਪਭੋਗਤਾ ਪ੍ਰਬੰਧਨ",
    "adminDashboard": "ਐਡਮਿਨ ਸੰਖੇਪ ਜਾਣਕਾਰੀ",
    "logout": "ਲਾਗਆਉਟ",
    "avgScore": "ਔਸਤ ਸਕੋਰ",
    "totalSessions": "ਸੈਸ਼ਨ",
    "rank": "ਦਰਜਾ",
    "topMistakes": "ਪ੍ਰਮੁੱਖ ਗਲਤੀਆਂ",
    "quickStart": "ਤੇਜ਼ ਸ਼ੁਰੂਆਤ",
    "startTraining": "ਸਿਖਲਾਈ ਸ਼ੁਰੂ ਕਰੋ",
    "categoryProgress": "ਸ਼੍ਰੇਣੀ ਦੀ ਤਰੱਕੀ",
    "welcome": "ਜੀ ਆਇਆਂ ਨੂੰ",
    "noMistakes": "ਅਜੇ ਤੱਕ ਕੋਈ ਗਲਤੀ ਦਰਜ ਨਹੀਂ ਕੀਤੀ ਗਈ - ਅਭਿਆਸ ਕਰਦੇ ਰਹੋ!",
    "difficulty": "ਮੁਸ਼ਕਿਲ",
    "easy": "ਆਸਾਨ",
    "medium": "ਮੱਧਮ",
    "hard": "ਔਖਾ",
    "start": "ਸ਼ੁਰੂ ਕਰੋ",
    "submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
    "next": "ਅੱਗੇ",
    "correct": "ਸਹੀ",
    "incorrect": "ਗਲਤ",
    "explanation": "ਵਿਆਖਿਆ",
    "yourScore": "ਤੁਹਾਡਾ ਸਕੋਰ",
    "finish": "ਸਮਾਪਤ",
    "review": "ਕਾਲ ਤੋਂ ਬਾਅਦ ਦੀ ਸਮੀਖਿਆ",
    "callScript": "ਕਾਲ ਸਕ੍ਰਿਪਟ",
    "question": "ਸਵਾਲ",
    "selectAnswer": "ਆਪਣਾ ਜਵਾਬ ਚੁਣੋ",
    "scenarios": "ਦ੍ਰਿਸ਼",
    "formNarrative": "ਸ਼ਿਕਾਇਤ ਬਿਰਤਾਂਤ",
    "validate": "ਪ੍ਰਮਾਣਿਤ ਕਰੋ ਅਤੇ ਜਮ੍ਹਾਂ ਕਰੋ",
    "commonMistake": "ਆਮ ਗਲਤੀ",
    "correctAnswer": "ਸਹੀ ਜਵਾਬ",
    "yourEntry": "ਤੁਹਾਡੀ ਐਂਟਰੀ",
    "allCorrect": "ਸਾਰੇ ਖੇਤਰ ਸਹੀ!",
    "save": "ਬਦਲਾਅ ਬਚਾਓ",
    "editProfile": "ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਿਤ ਕਰੋ",
    "designation": "ਅਹੁਦਾ",
    "state": "ਰਾਜ",
    "changePassword": "ਪਾਸਵਰਡ ਬਦਲੋ",
    "currentPassword": "ਮੌਜੂਦਾ ਪਾਸਵਰਡ",
    "newPassword": "ਨਵਾਂ ਪਾਸਵਰਡ",
    "name": "ਨਾਮ",
    "role": "ਭੂਮਿਕਾ",
    "search": "ਖੋਜ",
    "export": "ਨਿਰਯਾਤ",
    "importUsers": "ਉਪਭੋਗਤਾ ਆਯਾਤ ਕਰੋ",
    "downloadTemplate": "ਟੈਂਪਲੇਟ ਡਾਊਨਲੋਡ ਕਰੋ",
    "delete": "ਮਿਟਾਓ",
    "makeAdmin": "ਐਡਮਿਨ ਬਣਾਓ",
    "makeTrainee": "ਸਿਖਿਆਰਥੀ ਬਣਾਓ",
    "leaderboard": "ਲੀਡਰਬੋਰਡ",
    "categoryDistribution": "ਸ਼੍ਰੇਣੀ ਵੰਡ",
    "stateDrilldown": "ਸਟੇਟ ਡਰਿਲ-ਡਾਊਨ",
    "trend": "ਗਤੀਵਿਧੀ ਦਾ ਰੁਝਾਨ",
    "createdAt": "ਬਣਾਇਆ",
    "actions": "ਕਾਰਵਾਈਆਂ",
    "attempts": "ਕੋਸ਼ਿਸ਼ਾਂ",
    "lesson": "ਸਬਕ",
    "pattern": "ਦੇਖਿਆ ਪੈਟਰਨ",
    "searchTaxonomy": "ਅਪਰਾਧ ਸ਼੍ਰੇਣੀਆਂ ਦੀ ਖੋਜ ਕਰੋ...",
    "txnFormat": "ਲੈਣ-ਦੇਣ ID ਫਾਰਮੈਟ",
    "portal": "NCRP ਪੋਰਟਲ ਸੈਕਸ਼ਨ",
    "checklist": "ਚੈੱਕਲਿਸਟ",
    "importResult": "ਆਯਾਤ ਨਤੀਜਾ",
    "created": "ਬਣਾਇਆ",
    "errors": "ਗਲਤੀਆਂ",
    "back": "ਪਿੱਛੇ",
    "lang": "ਭਾਸ਼ਾ",
    "noData": "ਅਜੇ ਤੱਕ ਕੋਈ ਡਾਟਾ ਨਹੀਂ",
    "loading": "ਲੋਡ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "doAsk": "ਪੁੱਛੋ",
    "dontAsk": "ਨਾ ਪੁੱਛੋ / ਕਦੇ ਨਾ ਕਰੋ",
    "govOfIndia": "ਭਾਰਤ ਸਰਕਾਰ",
    "mha": "ਗ੍ਰਹਿ ਮੰਤਰਾਲੇ",
    "helpline": "1930 ਹੈਲਪਲਾਈਨ",
    "i4c": "ਭਾਰਤੀ ਸਾਈਬਰ ਕ੍ਰਾਈਮ ਕੋਆਰਡੀਨੇਸ਼ਨ ਸੈਂਟਰ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "ਸਾਈਬਰ ਕ੍ਰਾਈਮ ਸ਼ਿਕਾਇਤਾਂ ਦੀ ਆਨਲਾਈਨ ਰਿਪੋਰਟ ਕਰਨ ਲਈ ਪੀੜਤਾਂ/ਸ਼ਿਕਾਇਤਕਰਤਾਵਾਂ ਦੀ ਸਹੂਲਤ ਲਈ ਭਾਰਤ ਸਰਕਾਰ ਦੀ ਪਹਿਲਕਦਮੀ",
    "natlHelpline": "ਨੈਸ਼ਨਲ ਹੈਲਪਲਾਈਨ",
    "i4cCentre": "ਭਾਰਤੀ ਸਾਈਬਰ ਕ੍ਰਾਈਮ ਕੋਆਰਡੀਨੇਸ਼ਨ ਸੈਂਟਰ",
    "screenReader": "ਸਕ੍ਰੀਨ ਰੀਡਰ ਐਕਸੈਸ",
    "marquee": "ਔਨਲਾਈਨ ਵਿੱਤੀ ਧੋਖਾਧੜੀ ਦੀ ਰਿਪੋਰਟ ਕਰਨ ਲਈ, ਤੁਰੰਤ ਨੈਸ਼ਨਲ ਹੈਲਪਲਾਈਨ 1930 'ਤੇ ਕਾਲ ਕਰੋ। ਫ੍ਰੀਜ਼ ਕੀਤੇ ਫੰਡਾਂ ਦੀ ਰਿਕਵਰੀ ਦੀਆਂ ਸੰਭਾਵਨਾਵਾਂ ਨੂੰ ਵੱਧ ਤੋਂ ਵੱਧ ਕਰਨ ਲਈ 24 ਘੰਟਿਆਂ ਦੇ ਅੰਦਰ ਸਾਈਬਰ ਅਪਰਾਧਾਂ ਦੀ ਰਿਪੋਰਟ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ। ਇਹ ਇੱਕ ਅੰਦਰੂਨੀ ਸਿਖਲਾਈ ਸਿਮੂਲੇਟਰ ਹੈ — ਸਿਰਫ਼ ਸਿੰਥੈਟਿਕ ਡੇਟਾ।"
  },
  "sa": {
    "appName": "१९३० प्रशिक्षण अनुकरणकर्ता",
    "appSub": "I4C कॉल लेकर प्रशिक्षण",
    "badgeNumber": "बिल्ला संख्या",
    "password": "गुप्तशब्द",
    "login": "लॉगिन",
    "loggingIn": "लॉग इन...",
    "signIn": "स्वस्य प्रशिक्षण खाते प्रवेशं कुर्वन्तु",
    "dashboard": "डैशबोर्ड",
    "mcq": "परिदृश्य MCQ",
    "liveCall": "लाइव कॉल",
    "ncrpForm": "एनसीआरपी प्रपत्र",
    "caseStudies": "प्रकरण अध्ययन",
    "reference": "सन्दर्भ मार्गदर्शिका",
    "sop": "SOP मार्गदर्शिका",
    "analytics": "विश्लेषणात्मकता",
    "profile": "प्रोफाइल",
    "users": "प्रयोक्ता प्रबन्धन",
    "adminDashboard": "एडमिन अवलोकन",
    "logout": "लॉगआउट",
    "avgScore": "औसत स्कोर",
    "totalSessions": "सत्रम्",
    "rank": "रैंक",
    "topMistakes": "शीर्ष त्रुटयः",
    "quickStart": "शीघ्र प्रारम्भ",
    "startTraining": "प्रशिक्षण प्रारम्भ",
    "categoryProgress": "श्रेणी प्रगति",
    "welcome": "पुनः स्वागतम्",
    "noMistakes": "अद्यापि कोऽपि त्रुटिः अभिलेखिता नास्ति — अभ्यासं कुर्वन्तु!",
    "difficulty": "कठिनता",
    "easy": "सहज",
    "medium": "मध्यम",
    "hard": "कठिन",
    "start": "आरम्भ",
    "submit": "प्रस्तुत करें",
    "next": "अनन्तरम्",
    "correct": "सम्यक्",
    "incorrect": "अशुद्ध",
    "explanation": "व्याख्या",
    "yourScore": "तव स्कोर",
    "finish": "समापन",
    "review": "आह्वानोत्तर समीक्षा",
    "callScript": "आह्वान लिपि",
    "question": "प्रश्न",
    "selectAnswer": "उत्तरं चिनोतु",
    "scenarios": "परिदृश्यानि",
    "formNarrative": "शिकायत आख्यान",
    "validate": "प्रमाणित करें एवं प्रस्तुत करें",
    "commonMistake": "सामान्य त्रुटि",
    "correctAnswer": "सही उत्तर",
    "yourEntry": "भवतः प्रवेशः",
    "allCorrect": "सर्वाणि क्षेत्राणि सम्यक् !",
    "save": "परिवर्तनं रक्षतु",
    "editProfile": "प्रोफाइल सम्पादय",
    "designation": "पदनाम",
    "state": "राज्य",
    "changePassword": "गुप्तशब्द परिवर्तन",
    "currentPassword": "वर्तमान गुप्तशब्द",
    "newPassword": "नयाँ गुप्तशब्द",
    "name": "नाम",
    "role": "भूमिका",
    "search": "अन्वेषण",
    "export": "निर्यात",
    "importUsers": "आयात प्रयोक्ता",
    "downloadTemplate": "डाउनलोड टेम्पलेट",
    "delete": "लोपये",
    "makeAdmin": "एडमिन बनाये",
    "makeTrainee": "प्रशिक्षु बनाये",
    "leaderboard": "लीडरबोर्ड",
    "categoryDistribution": "श्रेणी वितरण",
    "stateDrilldown": "राज्य ड्रिल-डाउन",
    "trend": "गतिविधि प्रवृत्ति",
    "createdAt": "सृष्टा",
    "actions": "कर्माणि",
    "attempts": "प्रयत्नाः",
    "lesson": "पाठ",
    "pattern": "अवलोकितप्रतिमान",
    "searchTaxonomy": "अपराध श्रेणियाँ अन्वेषण...",
    "txnFormat": "लेनदेन आईडी प्रारूप",
    "portal": "एनसीआरपी पोर्टल अनुभाग",
    "checklist": "जाँचसूची",
    "importResult": "आयात परिणाम",
    "created": "सृष्टा",
    "errors": "दोषाः",
    "back": "पृष्ठतः",
    "lang": "भाषा",
    "noData": "अद्यापि न दत्तांशः",
    "loading": "लोड हो रहा है...",
    "doAsk": "करो पृच्छ",
    "dontAsk": "मा पृच्छ / न कदाचन",
    "govOfIndia": "भारत सरकार",
    "mha": "गृह मंत्रालय",
    "helpline": "१९३० सहायतारेखा",
    "i4c": "भारतीय साइबर अपराध समन्वय केन्द्र (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "पीडितानां / शिकायतकर्तानां साइबरअपराधस्य शिकायतां ऑनलाइन प्रतिवेदनं कर्तुं सुविधां दातुं भारतसर्वकारस्य एकः उपक्रमः",
    "natlHelpline": "राष्ट्रीय हेल्पलाइन",
    "i4cCentre": "भारतीय साइबर अपराध समन्वय केन्द्र",
    "screenReader": "स्क्रीन रीडर एक्सेस",
    "marquee": "ऑनलाइन-वित्तीय-धोखाधडस्य सूचनां दातुं तत्क्षणमेव राष्ट्रिय-सहायता-रेखां १९३० इति सम्पर्कं कुर्वन्तु । जमेन धनस्य पुनर्प्राप्तेः सम्भावना अधिकतमं कर्तुं २४ घण्टानां अन्तः साइबरअपराधानां सूचनां दातव्या। एषः आन्तरिकप्रशिक्षणस्य अनुकरणकर्ता अस्ति — केवलं कृत्रिमदत्तांशः ।"
  },
  "sat": {
    "appName": "1930 ᱥᱤᱠᱷᱲᱟ ᱥᱤᱢᱩᱞᱮᱴᱚᱨ",
    "appSub": "I4C ᱠᱚᱞ ᱴᱮᱠᱟᱨ ᱥᱤᱠᱷᱲᱟ",
    "badgeNumber": "ᱵᱮᱡ ᱱᱟᱢᱵᱟᱨ",
    "password": "ᱯᱟᱥᱣᱟᱨᱰ",
    "login": "ᱞᱚᱜᱤᱱ",
    "loggingIn": "ᱞᱚᱜ ᱤᱱ ᱦᱩᱭ ᱠᱟᱱᱟ...",
    "signIn": "ᱟᱢᱟᱜ ᱥᱤᱠᱷᱲᱟ ᱠᱷᱟᱛᱟ ᱨᱮ ᱥᱟᱭᱤᱱ ᱤᱱ ᱢᱮ",
    "dashboard": "ᱰᱮᱥᱵᱚᱨᱰ",
    "mcq": "ᱥᱤᱱᱟᱨᱤᱭᱚ MCQ",
    "liveCall": "ᱞᱟᱭᱤᱵᱷ ᱠᱚᱞ",
    "ncrpForm": "NCRP ᱯᱷᱟᱨᱚᱢ",
    "caseStudies": "ᱠᱮᱥ ᱥᱴᱟᱰᱤᱡᱽ",
    "reference": "ᱨᱮᱯᱷᱨᱮᱱᱥ ᱜᱟᱭᱤᱰ",
    "sop": "SOP ᱜᱟᱭᱤᱰ",
    "analytics": "ᱮᱱᱟᱞᱤᱴᱤᱠᱥ",
    "profile": "ᱯᱨᱚᱯᱷᱟᱭᱤᱞ",
    "users": "ᱭᱩᱡᱚᱨ ᱢᱮᱱᱮᱡᱢᱮᱱᱴ",
    "adminDashboard": "ᱮᱰᱢᱤᱱ ᱚᱵᱷᱨᱵᱤᱭᱩ",
    "logout": "ᱞᱚᱜᱟᱩᱴ",
    "avgScore": "ᱟᱣᱨᱮᱡ ᱥᱠᱳᱨ",
    "totalSessions": "ᱥᱮᱥᱚᱱ",
    "rank": "ᱨᱮᱸᱠ",
    "topMistakes": "ᱴᱚᱯ ᱵᱷᱩᱞ",
    "quickStart": "ᱛᱤᱱᱮ ᱮᱛᱦᱚᱵ",
    "startTraining": "ᱥᱤᱠᱷᱲᱟ ᱮᱛᱦᱚᱵ ᱢᱮ",
    "categoryProgress": "ᱠᱮᱴᱮᱜᱚᱨᱤ ᱡᱚᱛᱚ",
    "welcome": "ᱫᱩᱦᱲᱟ ᱡᱚᱝ ᱢᱮ",
    "noMistakes": "ᱚᱲᱟᱜ ᱛᱟᱦᱮᱸᱱ ᱵᱷᱩᱞ ᱵᱟᱭ ᱫᱚᱨᱡᱟ — ᱟᱵᱷᱭᱟᱥ ᱡᱟᱨᱤ ᱫᱚᱦᱚᱭ ᱢᱮ!",
    "difficulty": "ᱠᱚᱴᱷᱤᱱ",
    "easy": "ᱞᱚᱦᱟ",
    "medium": "ᱢᱟᱡᱷᱤᱢ",
    "hard": "ᱠᱚᱴᱷᱤᱱ",
    "start": "ᱮᱛᱦᱚᱵ",
    "submit": "ᱡᱚᱢᱟ ᱢᱮ",
    "next": "ᱟᱨᱦᱚᱸ",
    "correct": "ᱥᱟᱦᱴᱟ",
    "incorrect": "ᱵᱷᱩᱞ",
    "explanation": "ᱵᱟᱭᱟᱱ",
    "yourScore": "ᱟᱢᱟᱜ ᱥᱠᱳᱨ",
    "finish": "ᱥᱟᱢᱟᱯᱛ ᱢᱮ",
    "review": "ᱠᱚᱞ ᱛᱟᱭᱚᱢ ᱥᱚᱢᱤᱠᱷᱭᱟ",
    "callScript": "ᱠᱚᱞ ᱥᱠᱨᱤᱯᱴ",
    "question": "ᱠᱩᱲᱤ",
    "selectAnswer": "ᱟᱢᱟᱜ ᱡᱚᱵᱟᱵ ᱵᱟᱪᱷᱟᱣ ᱢᱮ",
    "scenarios": "ᱥᱤᱱᱟᱨᱤᱭᱚ",
    "formNarrative": "ᱵᱮᱡᱟᱨ ᱠᱚᱛᱷᱟ",
    "validate": "ᱴᱷᱤᱠ ᱮᱢ ᱟᱨ ᱡᱚᱢᱟ ᱢᱮ",
    "commonMistake": "ᱡᱟᱛᱟ ᱵᱷᱩᱞ",
    "correctAnswer": "ᱥᱟᱦᱴᱟ ᱡᱚᱵᱟᱵ",
    "yourEntry": "ᱟᱢᱟᱜ ᱮᱱᱴᱨᱤ",
    "allCorrect": "ᱡᱚᱛᱚ ᱯᱷᱤᱞᱰ ᱥᱟᱦᱴᱟ!",
    "save": "ᱵᱚᱫᱚᱞ ᱥᱟᱸᱴᱟᱲᱟᱣ ᱢᱮ",
    "editProfile": "ᱯᱨᱚᱯᱷᱟᱭᱤᱞ ᱮᱰᱤᱴ ᱢᱮ",
    "designation": "ᱚᱦᱚᱫᱟ",
    "state": "ᱨᱟᱡᱭᱚ",
    "changePassword": "ᱯᱟᱥᱣᱟᱨᱰ ᱵᱚᱫᱚᱞ ᱢᱮ",
    "currentPassword": "ᱱᱤᱛᱚᱜ ᱯᱟᱥᱣᱟᱨᱰ",
    "newPassword": "ᱱᱟᱶᱟ ᱯᱟᱥᱣᱟᱨᱰ",
    "name": "ᱧᱩᱛᱩᱢ",
    "role": "ᱨᱳᱞ",
    "search": "ᱥᱮᱸᱫᱽᱨᱟ",
    "export": "ᱮᱠᱥᱯᱳᱨᱴ",
    "importUsers": "ᱭᱩᱡᱚᱨ ᱤᱢᱯᱳᱨᱴ ᱢᱮ",
    "downloadTemplate": "ᱴᱮᱢᱯᱞᱮᱴ ᱰᱟᱩᱱᱞᱳᱰ ᱢᱮ",
    "delete": "ᱢᱮᱴᱟᱣ ᱢᱮ",
    "makeAdmin": "ᱮᱰᱢᱤᱱ ᱵᱮᱱᱟᱣ ᱢᱮ",
    "makeTrainee": "ᱴᱨᱮᱱᱤ ᱵᱮᱱᱟᱣ ᱢᱮ",
    "leaderboard": "ᱞᱤᱰᱚᱨᱵᱚᱨᱰ",
    "categoryDistribution": "ᱠᱮᱴᱮᱜᱚᱨᱤ ᱵᱟᱸᱴᱟ",
    "stateDrilldown": "ᱨᱟᱡᱭᱚ ᱰᱨᱤᱞ-ᱰᱟᱩᱱ",
    "trend": "ᱠᱟᱹᱢᱤ ᱨᱩᱡᱷᱟᱱ",
    "createdAt": "ᱛᱮᱭᱟᱨ",
    "actions": "ᱠᱟᱹᱢᱤ",
    "attempts": "ᱠᱚᱥᱤᱥ",
    "lesson": "ᱯᱟᱴᱷᱟ",
    "pattern": "ᱧᱮᱞ ᱮᱱᱟ ᱱᱟᱢᱩᱱᱟ",
    "searchTaxonomy": "ᱜᱩᱱᱟᱦ ᱠᱮᱴᱮᱜᱚᱨᱤ ᱥᱮᱸᱫᱽᱨᱟ ᱢᱮ...",
    "txnFormat": "ᱴᱨᱟᱱᱡᱮᱠᱥᱚᱱ ID ᱯᱷᱳᱨᱢᱟᱴ",
    "portal": "NCRP ᱯᱳᱨᱴᱟᱞ ᱥᱮᱠᱥᱚᱱ",
    "checklist": "ᱪᱮᱠᱞᱤᱥᱴ",
    "importResult": "ᱤᱢᱯᱳᱨᱴ ᱨᱤᱡᱚᱞᱴ",
    "created": "ᱛᱮᱭᱟᱨ",
    "errors": "ᱵᱷᱩᱞ",
    "back": "ᱛᱟᱭᱚᱢ",
    "lang": "ᱯᱟᱨᱥᱤ",
    "noData": "ᱚᱲᱟᱜ ᱛᱟᱦᱮᱸᱱ ᱰᱟᱴᱟ ᱵᱟᱭ",
    "loading": "ᱞᱚᱰ ᱦᱩᱭ ᱠᱟᱱᱟ...",
    "doAsk": "ᱠᱩᱲᱤ ᱢᱮ",
    "dontAsk": "ᱟᱲᱟᱜ ᱠᱩᱲᱤ / ᱛᱤᱥ ᱮᱥ ᱟᱲᱟᱜ ᱢᱮ",
    "govOfIndia": "ᱵᱷᱟᱨᱚᱛ ᱥᱚᱨᱠᱟᱨ",
    "mha": "ᱚᱲᱟᱜ ᱢᱚᱴᱨᱮᱭ",
    "helpline": "1930 ᱦᱮᱞᱯᱞᱟᱭᱤᱱ",
    "i4c": "ᱤᱱᱰᱤᱭᱟᱱ ᱥᱟᱭᱵᱚᱨ ᱠᱨᱟᱭᱤᱢ ᱠᱳᱠᱳᱨᱰᱤᱱᱮᱥᱚᱱ ᱥᱮᱸᱴᱟᱨ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "ᱥᱟᱭᱵᱚᱨ ᱠᱨᱟᱭᱤᱢ ᱠᱟᱦᱱᱤ ᱚᱱᱞᱟᱭᱤᱱ ᱨᱮ ᱨᱤᱯᱳᱨᱴ ᱠᱚᱨᱟᱣ ᱞᱟᱹᱜᱤᱫ ᱫᱩᱠᱷᱤ/ᱠᱟᱦᱱᱤᱭᱟᱹ ᱞᱟᱹᱜᱤᱫ ᱟᱡ ᱠᱚᱨᱮ ᱵᱷᱟᱨᱚᱛ ᱥᱚᱨᱠᱟᱨ ᱨᱮᱭᱟᱜ ᱮᱠᱟ ᱠᱟᱹᱢᱤ",
    "natlHelpline": "ᱨᱟᱥᱴᱨᱤᱭᱟ ᱦᱮᱞᱯᱞᱟᱭᱤᱱ",
    "i4cCentre": "ᱤᱱᱰᱤᱭᱟᱱ ᱥᱟᱭᱵᱚᱨ ᱠᱨᱟᱭᱤᱢ ᱠᱳᱠᱳᱨᱰᱤᱱᱮᱥᱚᱱ ᱥᱮᱸᱴᱟᱨ",
    "screenReader": "ᱥᱠᱨᱤᱱ ᱨᱤᱰᱚᱨ ᱮᱠᱥᱮᱥ",
    "marquee": "ᱚᱱᱞᱟᱭᱤᱱ ᱫᱟᱢ ᱮᱴᱦᱚᱵ ᱨᱤᱯᱳᱨᱴ ᱞᱟᱹᱜᱤᱫ, ᱛᱤᱱᱮ ᱨᱟᱥᱴᱨᱤᱭᱟ ᱦᱮᱞᱯᱞᱟᱭᱤᱱ 1930 ᱨᱮ ᱠᱚᱞ ᱢᱮ. ᱯᱷᱨᱤᱡ ᱴᱟᱠᱟ ᱨᱤᱠᱚᱵᱷᱚᱨᱤ ᱡᱚᱛᱚ ᱵᱟᱲᱟᱭ ᱞᱟᱹᱜᱤᱫ ᱥᱟᱭᱵᱚᱨ ᱠᱨᱟᱭᱤᱢ 24 ᱴᱟᱸᱴᱟᱹ ᱥᱮᱛᱟᱜ ᱨᱤᱯᱳᱨᱴ ᱠᱚᱨᱟᱣ ᱡᱟᱨᱩᱨᱤ ᱠᱟᱱᱟ. ᱱᱚᱶᱟ ᱡᱚᱛᱚ ᱚᱲᱟᱜ ᱥᱤᱠᱷᱲᱟ ᱥᱤᱢᱩᱞᱮᱴᱚᱨ ᱠᱟᱱᱟ — ᱥᱤᱱᱛᱮᱴᱤᱠ ᱰᱟᱴᱟ ᱠᱷᱟᱱ."
  },
  "sd": {
    "appName": "1930 ٽريننگ سموليٽر",
    "appSub": "I4C ڪال ٽيڪر ٽريننگ",
    "badgeNumber": "بيج نمبر",
    "password": "پاسورڊ",
    "login": "لاگ ان",
    "loggingIn": "لاگ ان ٿي رهيو آهي...",
    "signIn": "پنهنجي ٽريننگ اڪائونٽ ۾ سائن ان ٿيو",
    "dashboard": "ڊيش بورڊ",
    "mcq": "منظرنامو MCQ",
    "liveCall": "لائيو ڪال",
    "ncrpForm": "NCRP فارم",
    "caseStudies": "ڪيس اسٽڊيز",
    "reference": "ريفرنس گائيڊ",
    "sop": "SOP ھدايت",
    "analytics": "تجزياتي",
    "profile": "پروفائيل",
    "users": "يوزر مينيجمينٽ",
    "adminDashboard": "منتظم جو جائزو",
    "logout": "لاگ آئوٽ",
    "avgScore": "سراسري سکور",
    "totalSessions": "سيشنز",
    "rank": "درجو",
    "topMistakes": "مٿيون غلطيون",
    "quickStart": "جلدي شروع",
    "startTraining": "ٽريننگ شروع ڪريو",
    "categoryProgress": "درجي جي ترقي",
    "welcome": "واپس ڀليڪار",
    "noMistakes": "اڃا تائين ڪابه غلطي رڪارڊ نه ڪئي وئي آهي - مشق رکو!",
    "difficulty": "مشڪل",
    "easy": "آسان",
    "medium": "وچولي",
    "hard": "سخت",
    "start": "شروع ڪريو",
    "submit": "جمع ڪرايو",
    "next": "اڳيون",
    "correct": "صحيح",
    "incorrect": "غلط",
    "explanation": "وضاحت",
    "yourScore": "توهان جو سکور",
    "finish": "ختم ڪريو",
    "review": "پوسٽ-ڪال جو جائزو",
    "callScript": "ڪال اسڪرپٽ",
    "question": "سوال",
    "selectAnswer": "پنھنجو جواب چونڊيو",
    "scenarios": "منظرنامو",
    "formNarrative": "شڪايت جي داستان",
    "validate": "تصديق ڪريو ۽ جمع ڪرايو",
    "commonMistake": "عام غلطي",
    "correctAnswer": "صحيح جواب",
    "yourEntry": "توهان جي داخلا",
    "allCorrect": "سڀ شعبا صحيح!",
    "save": "تبديليون محفوظ ڪريو",
    "editProfile": "پروفائل تبديل ڪريو",
    "designation": "عهدو",
    "state": "رياست",
    "changePassword": "پاسورڊ تبديل ڪريو",
    "currentPassword": "موجوده پاسورڊ",
    "newPassword": "نئون پاسورڊ",
    "name": "نالو",
    "role": "ڪردار",
    "search": "ڳولهي",
    "export": "برآمد",
    "importUsers": "استعمال ڪندڙ درآمد ڪريو",
    "downloadTemplate": "ڊائون لوڊ سانچو",
    "delete": "حذف ڪريو",
    "makeAdmin": "ايڊمن ٺاهيو",
    "makeTrainee": "ٽريني ٺاهيو",
    "leaderboard": "ليڊر بورڊ",
    "categoryDistribution": "درجي جي ورڇ",
    "stateDrilldown": "اسٽيٽ ڊرل-ڊائون",
    "trend": "سرگرمي جو رجحان",
    "createdAt": "ٺاهي وئي",
    "actions": "عمل",
    "attempts": "ڪوششون",
    "lesson": "سبق",
    "pattern": "مشاهدو ٿيل نمونو",
    "searchTaxonomy": "ڏوهن جا درجا ڳولھيو...",
    "txnFormat": "ٽرانزيڪشن ID فارميٽ",
    "portal": "NCRP پورٽل سيڪشن",
    "checklist": "چيڪ لسٽ",
    "importResult": "درآمد جا نتيجا",
    "created": "ٺاهي وئي",
    "errors": "غلطيون",
    "back": "پوئتي",
    "lang": "ٻولي",
    "noData": "اڃان تائين ڪا به ڊيٽا ناهي",
    "loading": "لوڊ ٿي رهيو آهي...",
    "doAsk": "پڇو",
    "dontAsk": "نه پڇو / ڪڏھن نه ڪريو",
    "govOfIndia": "هندستان جي حڪومت",
    "mha": "گهرو معاملن جي وزارت",
    "helpline": "1930 هيلپ لائن",
    "i4c": "انڊين سائبر ڪرائم ڪوآرڊينيشن سينٽر (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "سائبر ڪرائم جون شڪايتون آن لائن رپورٽ ڪرڻ لاءِ متاثرين / شڪايت ڪندڙن کي سهولت ڏيڻ لاءِ هندستان جي حڪومت جي شروعات",
    "natlHelpline": "قومي مدد",
    "i4cCentre": "انڊين سائبر ڪرائم ڪوآرڊينيشن سينٽر",
    "screenReader": "اسڪرين ريڊر جي رسائي",
    "marquee": "آن لائن مالي فراڊ جي رپورٽ ڪرڻ لاء، فوري طور تي نيشنل هيلپ لائن 1930 تي ڪال ڪريو. منجمد پئسن جي وصولي جا موقعا وڌائڻ لاءِ سائبر ڪرائمز کي 24 ڪلاڪن اندر رپورٽ ڪيو وڃي. هي هڪ اندروني ٽريننگ سمائيٽر آهي - صرف مصنوعي ڊيٽا."
  },
  "ta": {
    "appName": "1930 பயிற்சி சிமுலேட்டர்",
    "appSub": "I4C கால் டேக்கர் பயிற்சி",
    "badgeNumber": "பேட்ஜ் எண்",
    "password": "கடவுச்சொல்",
    "login": "உள்நுழை",
    "loggingIn": "உள்நுழைகிறேன்...",
    "signIn": "உங்கள் பயிற்சி கணக்கில் உள்நுழையவும்",
    "dashboard": "டாஷ்போர்டு",
    "mcq": "காட்சி MCQ",
    "liveCall": "நேரடி அழைப்பு",
    "ncrpForm": "NCRP படிவம்",
    "caseStudies": "வழக்கு ஆய்வுகள்",
    "reference": "குறிப்பு வழிகாட்டி",
    "sop": "SOP வழிகாட்டி",
    "analytics": "பகுப்பாய்வு",
    "profile": "சுயவிவரம்",
    "users": "பயனர் மேலாண்மை",
    "adminDashboard": "நிர்வாக மேலோட்டம்",
    "logout": "வெளியேறு",
    "avgScore": "சராசரி மதிப்பெண்",
    "totalSessions": "அமர்வுகள்",
    "rank": "தரவரிசை",
    "topMistakes": "முக்கிய தவறுகள்",
    "quickStart": "விரைவு ஆரம்பம்",
    "startTraining": "பயிற்சியைத் தொடங்கு",
    "categoryProgress": "வகை முன்னேற்றம்",
    "welcome": "மீண்டும் வருக",
    "noMistakes": "இதுவரை எந்த தவறும் பதிவு செய்யப்படவில்லை — தொடர்ந்து பயிற்சி செய்யுங்கள்!",
    "difficulty": "சிரமம்",
    "easy": "எளிதானது",
    "medium": "நடுத்தர",
    "hard": "கடினமான",
    "start": "தொடக்கம்",
    "submit": "சமர்ப்பிக்கவும்",
    "next": "அடுத்து",
    "correct": "சரியா",
    "incorrect": "தவறான",
    "explanation": "விளக்கம்",
    "yourScore": "உங்கள் மதிப்பெண்",
    "finish": "முடிக்கவும்",
    "review": "போஸ்ட்-அழைப்பு விமர்சனம்",
    "callScript": "அழைப்பு ஸ்கிரிப்ட்",
    "question": "கேள்வி",
    "selectAnswer": "உங்கள் பதிலைத் தேர்ந்தெடுக்கவும்",
    "scenarios": "காட்சிகள்",
    "formNarrative": "புகார் விவரிப்பு",
    "validate": "சரிபார்த்து சமர்ப்பிக்கவும்",
    "commonMistake": "பொதுவான தவறு",
    "correctAnswer": "சரியான பதில்",
    "yourEntry": "உங்கள் பதிவு",
    "allCorrect": "அனைத்து துறைகளும் சரி!",
    "save": "மாற்றங்களை சேமி",
    "editProfile": "சுயவிவரத்தைத் திருத்து",
    "designation": "பதவி",
    "state": "மாநிலம்",
    "changePassword": "கடவுச்சொல்லை மாற்று",
    "currentPassword": "தற்போதைய கடவுச்சொல்",
    "newPassword": "புதிய கடவுச்சொல்",
    "name": "பெயர்",
    "role": "பங்கு",
    "search": "தேடல்",
    "export": "ஏற்றுமதி",
    "importUsers": "பயனர்களை இறக்குமதி செய்",
    "downloadTemplate": "பதிவிறக்க டெம்ப்ளேட்",
    "delete": "நீக்கு",
    "makeAdmin": "நிர்வாகியை உருவாக்கு",
    "makeTrainee": "பயிற்சி பெறுங்கள்",
    "leaderboard": "லீடர்போர்டு",
    "categoryDistribution": "வகை விநியோகம்",
    "stateDrilldown": "மாநில டிரில்-டவுன்",
    "trend": "செயல்பாட்டுப் போக்கு",
    "createdAt": "உருவாக்கப்பட்டது",
    "actions": "செயல்கள்",
    "attempts": "முயற்சிகள்",
    "lesson": "பாடம்",
    "pattern": "கவனிக்கப்பட்ட முறை",
    "searchTaxonomy": "குற்ற வகைகளைத் தேடுங்கள்...",
    "txnFormat": "பரிவர்த்தனை ஐடி வடிவம்",
    "portal": "NCRP போர்டல் பிரிவு",
    "checklist": "சரிபார்ப்பு பட்டியல்",
    "importResult": "இறக்குமதி முடிவு",
    "created": "உருவாக்கப்பட்டது",
    "errors": "பிழைகள்",
    "back": "பின்",
    "lang": "மொழி",
    "noData": "இன்னும் தரவு இல்லை",
    "loading": "ஏற்றுகிறது...",
    "doAsk": "கேளுங்கள்",
    "dontAsk": "கேட்காதே / ஒருபோதும் செய்யாதே",
    "govOfIndia": "இந்திய அரசு",
    "mha": "உள்துறை அமைச்சகம்",
    "helpline": "1930 ஹெல்ப்லைன்",
    "i4c": "இந்திய சைபர் கிரைம் ஒருங்கிணைப்பு மையம் (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "சைபர் கிரைம் புகார்களை ஆன்லைனில் புகாரளிக்க பாதிக்கப்பட்டவர்கள் / புகார்தாரர்களை எளிதாக்குவதற்கான இந்திய அரசின் முயற்சி",
    "natlHelpline": "நேஷனல் ஹெல்ப்லைன்",
    "i4cCentre": "இந்திய சைபர் கிரைம் ஒருங்கிணைப்பு மையம்",
    "screenReader": "ஸ்கிரீன் ரீடர் அணுகல்",
    "marquee": "ஆன்லைன் நிதி மோசடியைப் புகாரளிக்க, தேசிய ஹெல்ப்லைன் 1930ஐ உடனடியாக அழைக்கவும். முடக்கப்பட்ட நிதிகளின் மீட்பு வாய்ப்புகளை அதிகரிக்க சைபர் கிரைம்கள் 24 மணி நேரத்திற்குள் புகாரளிக்கப்பட வேண்டும். இது ஒரு உள் பயிற்சி சிமுலேட்டர் - செயற்கை தரவு மட்டுமே."
  },
  "te": {
    "appName": "1930 ట్రైనింగ్ సిమ్యులేటర్",
    "appSub": "I4C కాల్ టేకర్ శిక్షణ",
    "badgeNumber": "బ్యాడ్జ్ సంఖ్య",
    "password": "పాస్వర్డ్",
    "login": "లాగిన్",
    "loggingIn": "లాగిన్ అవుతోంది...",
    "signIn": "మీ శిక్షణ ఖాతాకు సైన్ ఇన్ చేయండి",
    "dashboard": "డాష్‌బోర్డ్",
    "mcq": "దృశ్యం MCQ",
    "liveCall": "ప్రత్యక్ష కాల్",
    "ncrpForm": "NCRP ఫారమ్",
    "caseStudies": "కేస్ స్టడీస్",
    "reference": "రిఫరెన్స్ గైడ్",
    "sop": "SOP గైడ్",
    "analytics": "విశ్లేషణలు",
    "profile": "ప్రొఫైల్",
    "users": "వినియోగదారు నిర్వహణ",
    "adminDashboard": "అడ్మిన్ అవలోకనం",
    "logout": "లాగ్అవుట్",
    "avgScore": "సగటు స్కోరు",
    "totalSessions": "సెషన్స్",
    "rank": "ర్యాంక్",
    "topMistakes": "అగ్ర తప్పులు",
    "quickStart": "త్వరిత ప్రారంభం",
    "startTraining": "శిక్షణ ప్రారంభించు",
    "categoryProgress": "వర్గం పురోగతి",
    "welcome": "తిరిగి స్వాగతం",
    "noMistakes": "ఇంకా తప్పులు నమోదు చేయబడలేదు — సాధన కొనసాగించండి!",
    "difficulty": "కష్టం",
    "easy": "సులువు",
    "medium": "మధ్యస్థం",
    "hard": "హార్డ్",
    "start": "ప్రారంభం",
    "submit": "సమర్పించు",
    "next": "తదుపరి",
    "correct": "కరెక్ట్",
    "incorrect": "తప్పు",
    "explanation": "వివరణ",
    "yourScore": "మీ స్కోర్",
    "finish": "ముగించు",
    "review": "పోస్ట్-కాల్ సమీక్ష",
    "callScript": "కాల్ స్క్రిప్ట్",
    "question": "ప్రశ్న",
    "selectAnswer": "మీ సమాధానాన్ని ఎంచుకోండి",
    "scenarios": "దృశ్యాలు",
    "formNarrative": "ఫిర్యాదు కథనం",
    "validate": "ధృవీకరించు & సమర్పించు",
    "commonMistake": "సాధారణ తప్పు",
    "correctAnswer": "సరైన సమాధానం",
    "yourEntry": "మీ ఎంట్రీ",
    "allCorrect": "అన్ని ఫీల్డ్‌లు సరైనవి!",
    "save": "మార్పులను సేవ్ చేయి",
    "editProfile": "ప్రొఫైల్‌ని సవరించండి",
    "designation": "హోదా",
    "state": "రాష్ట్రం",
    "changePassword": "పాస్‌వర్డ్ మార్చండి",
    "currentPassword": "ప్రస్తుత పాస్‌వర్డ్",
    "newPassword": "కొత్త పాస్‌వర్డ్",
    "name": "పేరు",
    "role": "పాత్ర",
    "search": "శోధన",
    "export": "ఎగుమతి",
    "importUsers": "వినియోగదారులను దిగుమతి చేయండి",
    "downloadTemplate": "మూసను డౌన్‌లోడ్ చేయండి",
    "delete": "తొలగించు",
    "makeAdmin": "అడ్మిన్ చేయండి",
    "makeTrainee": "శిక్షణ పొందండి",
    "leaderboard": "లీడర్‌బోర్డ్",
    "categoryDistribution": "వర్గం పంపిణీ",
    "stateDrilldown": "స్టేట్ డ్రిల్-డౌన్",
    "trend": "కార్యాచరణ ధోరణి",
    "createdAt": "సృష్టించబడింది",
    "actions": "చర్యలు",
    "attempts": "ప్రయత్నాలు",
    "lesson": "పాఠం",
    "pattern": "గమనించిన నమూనా",
    "searchTaxonomy": "నేర వర్గాలను శోధించండి...",
    "txnFormat": "లావాదేవీ ID ఫార్మాట్",
    "portal": "NCRP పోర్టల్ విభాగం",
    "checklist": "చెక్‌లిస్ట్",
    "importResult": "దిగుమతి ఫలితం",
    "created": "సృష్టించబడింది",
    "errors": "లోపాలు",
    "back": "వెనుకకు",
    "lang": "భాష",
    "noData": "ఇంకా డేటా లేదు",
    "loading": "లోడ్ అవుతోంది...",
    "doAsk": "అడగండి",
    "dontAsk": "అడగవద్దు / ఎప్పుడూ చేయవద్దు",
    "govOfIndia": "భారత ప్రభుత్వం",
    "mha": "హోం వ్యవహారాల మంత్రిత్వ శాఖ",
    "helpline": "1930 హెల్ప్‌లైన్",
    "i4c": "ఇండియన్ సైబర్ క్రైమ్ కోఆర్డినేషన్ సెంటర్ (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "సైబర్ క్రైమ్ ఫిర్యాదులను ఆన్‌లైన్‌లో నివేదించడానికి బాధితులు / ఫిర్యాదుదారులను సులభతరం చేయడానికి భారత ప్రభుత్వ చొరవ",
    "natlHelpline": "నేషనల్ హెల్ప్‌లైన్",
    "i4cCentre": "ఇండియన్ సైబర్ క్రైమ్ కోఆర్డినేషన్ సెంటర్",
    "screenReader": "స్క్రీన్ రీడర్ యాక్సెస్",
    "marquee": "ఆన్‌లైన్ ఆర్థిక మోసాన్ని నివేదించడం కోసం, వెంటనే నేషనల్ హెల్ప్‌లైన్ 1930కి కాల్ చేయండి. స్తంభింపచేసిన నిధుల రికవరీ అవకాశాలను పెంచడానికి సైబర్ నేరాలను తప్పనిసరిగా 24 గంటలలోపు నివేదించాలి. ఇది అంతర్గత శిక్షణ సిమ్యులేటర్ — సింథటిక్ డేటా మాత్రమే."
  },
  "ur": {
    "appName": "1930 ٹریننگ سمیلیٹر",
    "appSub": "I4C کال ٹیکر ٹریننگ",
    "badgeNumber": "بیج نمبر",
    "password": "پاس ورڈ",
    "login": "لاگ ان",
    "loggingIn": "لاگ ان ہو رہا ہے...",
    "signIn": "اپنے ٹریننگ اکاؤنٹ میں سائن ان کریں",
    "dashboard": "ڈیش بورڈ",
    "mcq": "منظر نامہ MCQ",
    "liveCall": "لائیو کال",
    "ncrpForm": "NCRP فارم",
    "caseStudies": "کیس اسٹڈیز",
    "reference": "حوالہ گائیڈ",
    "sop": "ایس او پی گائیڈ",
    "analytics": "تجزیات",
    "profile": "پروفائل",
    "users": "یوزر مینجمنٹ",
    "adminDashboard": "ایڈمن کا جائزہ",
    "logout": "لاگ آؤٹ",
    "avgScore": "اوسط سکور",
    "totalSessions": "سیشنز",
    "rank": "درجہ",
    "topMistakes": "سرفہرست غلطیاں",
    "quickStart": "فوری آغاز",
    "startTraining": "ٹریننگ شروع کریں",
    "categoryProgress": "زمرہ کی پیشرفت",
    "welcome": "دوبارہ خوش آمدید",
    "noMistakes": "ابھی تک کوئی غلطی ریکارڈ نہیں ہوئی — مشق کرتے رہیں!",
    "difficulty": "مشکل",
    "easy": "آسان",
    "medium": "میڈیم",
    "hard": "مشکل",
    "start": "شروع کریں",
    "submit": "جمع کروائیں",
    "next": "اگلا",
    "correct": "درست",
    "incorrect": "غلط",
    "explanation": "وضاحت",
    "yourScore": "آپ کا سکور",
    "finish": "ختم کرنا",
    "review": "کال کے بعد کا جائزہ",
    "callScript": "کال اسکرپٹ",
    "question": "سوال",
    "selectAnswer": "اپنا جواب منتخب کریں",
    "scenarios": "منظرنامے",
    "formNarrative": "شکایت کی داستان",
    "validate": "توثیق کریں اور جمع کرائیں",
    "commonMistake": "عام غلطی",
    "correctAnswer": "درست جواب",
    "yourEntry": "آپ کا داخلہ",
    "allCorrect": "تمام فیلڈز درست!",
    "save": "تبدیلیاں محفوظ کریں",
    "editProfile": "پروفائل میں ترمیم کریں",
    "designation": "عہدہ",
    "state": "ریاست",
    "changePassword": "پاس ورڈ تبدیل کریں",
    "currentPassword": "موجودہ پاس ورڈ",
    "newPassword": "نیا پاس ورڈ",
    "name": "نام",
    "role": "کردار",
    "search": "تلاش کریں",
    "export": "ایکسپورٹ",
    "importUsers": "صارفین کو درآمد کریں",
    "downloadTemplate": "سانچہ ڈاؤن لوڈ کریں",
    "delete": "حذف کریں",
    "makeAdmin": "ایڈمن بنائیں",
    "makeTrainee": "ٹرینی بنائیں",
    "leaderboard": "لیڈر بورڈ",
    "categoryDistribution": "زمرہ کی تقسیم",
    "stateDrilldown": "ریاستی ڈرل ڈاؤن",
    "trend": "سرگرمی کا رجحان",
    "createdAt": "تخلیق کردہ",
    "actions": "اعمال",
    "attempts": "کوششیں",
    "lesson": "سبق",
    "pattern": "مشاہدہ شدہ پیٹرن",
    "searchTaxonomy": "جرائم کے زمرے تلاش کریں...",
    "txnFormat": "ٹرانزیکشن ID فارمیٹ",
    "portal": "NCRP پورٹل سیکشن",
    "checklist": "چیک لسٹ",
    "importResult": "نتیجہ درآمد کریں",
    "created": "تخلیق کردہ",
    "errors": "غلطیاں",
    "back": "واپس",
    "lang": "زبان",
    "noData": "ابھی تک کوئی ڈیٹا نہیں",
    "loading": "لوڈ ہو رہا ہے...",
    "doAsk": "پوچھو",
    "dontAsk": "مت پوچھو / کبھی نہ کرو",
    "govOfIndia": "حکومت ہند",
    "mha": "وزارت داخلہ",
    "helpline": "1930 ہیلپ لائن",
    "i4c": "انڈین سائبر کرائم کوآرڈینیشن سینٹر (I4C)",
    "portalHi": "राष्ट्रीय साइबर अपराध रिपोर्टिंग पोर्टल",
    "portalEn": "National Cyber Crime Reporting Portal",
    "portalTag": "سائبر کرائم کی شکایات آن لائن رپورٹ کرنے کے لیے متاثرین/شکایت کنندگان کی سہولت کے لیے حکومت ہند کا ایک اقدام",
    "natlHelpline": "قومی ہیلپ لائن",
    "i4cCentre": "انڈین سائبر کرائم کوآرڈینیشن سینٹر",
    "screenReader": "سکرین ریڈر تک رسائی",
    "marquee": "آن لائن مالی فراڈ کی اطلاع دینے کے لیے، فوری طور پر نیشنل ہیلپ لائن 1930 پر کال کریں۔ منجمد رقوم کی بازیابی کے امکانات کو زیادہ سے زیادہ کرنے کے لیے سائبر کرائمز کی اطلاع 24 گھنٹوں کے اندر ہونی چاہیے۔ یہ ایک اندرونی تربیتی سمیلیٹر ہے — صرف مصنوعی ڈیٹا۔"
  }
};